export const MoCDuos = [
  {
    char: 'tribbie',
    app: 68.97,
    char_1: 'the-herta',
    app_rate_1: '65.81%',
    avg_round_1: 8.42,
    app_flat_1: 2112,
    char_2: 'herta',
    app_rate_2: '26.84%',
    avg_round_2: 8.5,
    app_flat_2: 913,
    char_3: 'jade',
    app_rate_3: '25.32%',
    avg_round_3: 8.41,
    app_flat_3: 780,
    char_4: 'huohuo',
    app_rate_4: '19.53%',
    avg_round_4: 8.72,
    app_flat_4: 533,
    char_5: 'aventurine',
    app_rate_5: '19.01%',
    avg_round_5: 8.55,
    app_flat_5: 579,
    char_6: 'sunday',
    app_rate_6: '16.33%',
    avg_round_6: 8.25,
    app_flat_6: 306,
    char_7: 'lingsha',
    app_rate_7: '15.92%',
    avg_round_7: 7.55,
    app_flat_7: 483,
    char_8: 'fu-xuan',
    app_rate_8: '15.67%',
    avg_round_8: 8.9,
    app_flat_8: 392,
    char_9: 'serval',
    app_rate_9: '13.2%',
    avg_round_9: 8.49,
    app_flat_9: 387,
    char_10: 'gallagher',
    app_rate_10: '10.14%',
    avg_round_10: 7.95,
    app_flat_10: 339,
    char_11: 'mydei',
    app_rate_11: '8.98%',
    avg_round_11: 8.11,
    app_flat_11: 267,
    char_12: 'trailblazer-remembrance',
    app_rate_12: '8.44%',
    avg_round_12: 7.78,
    app_flat_12: 210,
    char_13: 'luocha',
    app_rate_13: '7.61%',
    avg_round_13: 8.33,
    app_flat_13: 222,
    char_14: 'acheron',
    app_rate_14: '6.64%',
    avg_round_14: 8.27,
    app_flat_14: 63,
    char_15: 'robin',
    app_rate_15: '5.78%',
    avg_round_15: 8.89,
    app_flat_15: 71,
    char_16: 'aglaea',
    app_rate_16: '4.41%',
    avg_round_16: 8.78,
    app_flat_16: 71,
    char_17: 'jiaoqiu',
    app_rate_17: '4.04%',
    avg_round_17: 7.79,
    app_flat_17: 43,
    char_18: 'sparkle',
    app_rate_18: '3.69%',
    avg_round_18: 8.45,
    app_flat_18: 44,
    char_19: 'argenti',
    app_rate_19: '2.85%',
    avg_round_19: 7.38,
    app_flat_19: 90,
    char_20: 'pela',
    app_rate_20: '2.69%',
    avg_round_20: 8.19,
    app_flat_20: 30,
    char_21: 'jing-yuan',
    app_rate_21: '2.35%',
    avg_round_21: 9.06,
    app_flat_21: 33,
    char_22: 'feixiao',
    app_rate_22: '2.21%',
    avg_round_22: 9.44,
    app_flat_22: 32,
    char_23: 'yunli',
    app_rate_23: '1.75%',
    avg_round_23: 8.93,
    app_flat_23: 29,
    char_24: 'ruan-mei',
    app_rate_24: '1.4%',
    avg_round_24: 6.75,
    app_flat_24: 16,
    char_25: 'bronya',
    app_rate_25: '1.32%',
    avg_round_25: 7.81,
    app_flat_25: 26,
    char_26: 'jingliu',
    app_rate_26: '1.23%',
    avg_round_26: 9.67,
    app_flat_26: 10,
    char_27: 'blade',
    app_rate_27: '0.91%',
    avg_round_27: 8.56,
    app_flat_27: 9,
    char_28: 'imbibitor-lunae',
    app_rate_28: '0.69%',
    avg_round_28: 9.67,
    app_flat_28: 5,
    char_29: 'qingque',
    app_rate_29: '0.52%',
    avg_round_29: 7.6,
    app_flat_29: 5,
    char_30: 'clara',
    app_rate_30: '0.46%',
    avg_round_30: 9,
    app_flat_30: 9
  },
  {
    char: 'the-herta',
    app: 66.46,
    char_1: 'tribbie',
    app_rate_1: '68.3%',
    avg_round_1: 8.42,
    app_flat_1: 2112,
    char_2: 'herta',
    app_rate_2: '38.98%',
    avg_round_2: 8.86,
    app_flat_2: 1337,
    char_3: 'jade',
    app_rate_3: '37.78%',
    avg_round_3: 8.59,
    app_flat_3: 1182,
    char_4: 'aventurine',
    app_rate_4: '23.24%',
    avg_round_4: 8.67,
    app_flat_4: 815,
    char_5: 'lingsha',
    app_rate_5: '20.3%',
    avg_round_5: 8.37,
    app_flat_5: 660,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '19.01%',
    avg_round_6: 9.06,
    app_flat_6: 736,
    char_7: 'huohuo',
    app_rate_7: '18.74%',
    avg_round_7: 8.78,
    app_flat_7: 595,
    char_8: 'serval',
    app_rate_8: '18.28%',
    avg_round_8: 8.69,
    app_flat_8: 548,
    char_9: 'fu-xuan',
    app_rate_9: '16.19%',
    avg_round_9: 9.05,
    app_flat_9: 467,
    char_10: 'gallagher',
    app_rate_10: '10.02%',
    avg_round_10: 8.59,
    app_flat_10: 401,
    char_11: 'robin',
    app_rate_11: '8.91%',
    avg_round_11: 8.67,
    app_flat_11: 218,
    char_12: 'sunday',
    app_rate_12: '7.26%',
    avg_round_12: 8.93,
    app_flat_12: 211,
    char_13: 'luocha',
    app_rate_13: '4.39%',
    avg_round_13: 9.04,
    app_flat_13: 148,
    char_14: 'argenti',
    app_rate_14: '3.58%',
    avg_round_14: 7.29,
    app_flat_14: 115,
    char_15: 'ruan-mei',
    app_rate_15: '1.66%',
    avg_round_15: 9.16,
    app_flat_15: 35,
    char_16: 'sparkle',
    app_rate_16: '1.39%',
    avg_round_16: 9.3,
    app_flat_16: 18,
    char_17: 'bailu',
    app_rate_17: '0.37%',
    avg_round_17: 9.15,
    app_flat_17: 13,
    char_18: 'pela',
    app_rate_18: '0.26%',
    avg_round_18: 9.5,
    app_flat_18: 4,
    char_19: 'lynx',
    app_rate_19: '0.19%',
    avg_round_19: 9.17,
    app_flat_19: 6,
    char_20: 'gepard',
    app_rate_20: '0.18%',
    avg_round_20: 9.4,
    app_flat_20: 5,
    char_21: 'himeko',
    app_rate_21: '0.18%',
    avg_round_21: 6.5,
    app_flat_21: 4,
    char_22: 'jing-yuan',
    app_rate_22: '0.16%',
    avg_round_22: 8,
    app_flat_22: 2,
    char_23: 'bronya',
    app_rate_23: '0.16%',
    avg_round_23: 9.25,
    app_flat_23: 4,
    char_24: 'jiaoqiu',
    app_rate_24: '0.1%',
    avg_round_24: 7,
    app_flat_24: 1,
    char_25: 'march-7th',
    app_rate_25: '0.05%',
    avg_round_25: 8,
    app_flat_25: 1,
    char_26: 'qingque',
    app_rate_26: '0.05%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'rappa',
    app_rate_27: '0.03%',
    avg_round_27: 9,
    app_flat_27: 1,
    char_28: 'silver-wolf',
    app_rate_28: '0.03%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'tingyun-fugue',
    app_rate_29: '0.03%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'natasha',
    app_rate_30: '0.03%',
    avg_round_30: 8,
    app_flat_30: 1
  },
  {
    char: 'ruan-mei',
    app: 55.38,
    char_1: 'tingyun-fugue',
    app_rate_1: '63.53%',
    avg_round_1: 8.94,
    app_flat_1: 874,
    char_2: 'firefly',
    app_rate_2: '61.31%',
    avg_round_2: 9.45,
    app_flat_2: 609,
    char_3: 'lingsha',
    app_rate_3: '43.23%',
    avg_round_3: 9.2,
    app_flat_3: 582,
    char_4: 'trailblazer-harmony',
    app_rate_4: '36.87%',
    avg_round_4: 9.15,
    app_flat_4: 510,
    char_5: 'gallagher',
    app_rate_5: '26.93%',
    avg_round_5: 9.5,
    app_flat_5: 499,
    char_6: 'rappa',
    app_rate_6: '19.79%',
    avg_round_6: 8.94,
    app_flat_6: 555,
    char_7: 'sunday',
    app_rate_7: '6.8%',
    avg_round_7: 8.03,
    app_flat_7: 131,
    char_8: 'mydei',
    app_rate_8: '6.76%',
    avg_round_8: 8.0,
    app_flat_8: 177,
    char_9: 'boothill',
    app_rate_9: '4.16%',
    avg_round_9: 8.6,
    app_flat_9: 80,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '3.26%',
    avg_round_10: 6.7,
    app_flat_10: 71,
    char_11: 'huohuo',
    app_rate_11: '3.26%',
    avg_round_11: 9.0,
    app_flat_11: 40,
    char_12: 'luocha',
    app_rate_12: '3.1%',
    avg_round_12: 9.18,
    app_flat_12: 63,
    char_13: 'aventurine',
    app_rate_13: '2.7%',
    avg_round_13: 9.29,
    app_flat_13: 39,
    char_14: 'bronya',
    app_rate_14: '2.03%',
    avg_round_14: 7.53,
    app_flat_14: 30,
    char_15: 'the-herta',
    app_rate_15: '1.99%',
    avg_round_15: 9.16,
    app_flat_15: 35,
    char_16: 'tribbie',
    app_rate_16: '1.74%',
    avg_round_16: 6.75,
    app_flat_16: 16,
    char_17: 'sparkle',
    app_rate_17: '1.59%',
    avg_round_17: 7.89,
    app_flat_17: 17,
    char_18: 'jade',
    app_rate_18: '1.44%',
    avg_round_18: 9.07,
    app_flat_18: 28,
    char_19: 'imbibitor-lunae',
    app_rate_19: '1.34%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'fu-xuan',
    app_rate_20: '1.3%',
    avg_round_20: 9.36,
    app_flat_20: 11,
    char_21: 'acheron',
    app_rate_21: '0.88%',
    avg_round_21: 9,
    app_flat_21: 1,
    char_22: 'jiaoqiu',
    app_rate_22: '0.86%',
    avg_round_22: 6.67,
    app_flat_22: 3,
    char_23: 'herta',
    app_rate_23: '0.75%',
    avg_round_23: 10.0,
    app_flat_23: 8,
    char_24: 'kafka',
    app_rate_24: '0.73%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'black-swan',
    app_rate_25: '0.73%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'robin',
    app_rate_26: '0.56%',
    avg_round_26: 9,
    app_flat_26: 1,
    char_27: 'aglaea',
    app_rate_27: '0.52%',
    avg_round_27: 10,
    app_flat_27: 1,
    char_28: 'jing-yuan',
    app_rate_28: '0.42%',
    avg_round_28: 9.5,
    app_flat_28: 4,
    char_29: 'jingliu',
    app_rate_29: '0.42%',
    avg_round_29: 8.67,
    app_flat_29: 3,
    char_30: 'pela',
    app_rate_30: '0.34%',
    avg_round_30: 5.67,
    app_flat_30: 3
  },
  {
    char: 'lingsha',
    app: 42.35,
    char_1: 'ruan-mei',
    app_rate_1: '56.54%',
    avg_round_1: 9.2,
    app_flat_1: 582,
    char_2: 'tingyun-fugue',
    app_rate_2: '47.95%',
    avg_round_2: 9.04,
    app_flat_2: 491,
    char_3: 'firefly',
    app_rate_3: '41.03%',
    avg_round_3: 9.48,
    app_flat_3: 308,
    char_4: 'the-herta',
    app_rate_4: '31.86%',
    avg_round_4: 8.37,
    app_flat_4: 660,
    char_5: 'tribbie',
    app_rate_5: '25.93%',
    avg_round_5: 7.55,
    app_flat_5: 483,
    char_6: 'trailblazer-harmony',
    app_rate_6: '18.24%',
    avg_round_6: 9.28,
    app_flat_6: 189,
    char_7: 'jade',
    app_rate_7: '17.84%',
    avg_round_7: 8.18,
    app_flat_7: 357,
    char_8: 'rappa',
    app_rate_8: '14.18%',
    avg_round_8: 8.88,
    app_flat_8: 298,
    char_9: 'herta',
    app_rate_9: '10.12%',
    avg_round_9: 8.74,
    app_flat_9: 223,
    char_10: 'robin',
    app_rate_10: '7.04%',
    avg_round_10: 8.46,
    app_flat_10: 96,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '6.49%',
    avg_round_11: 9.15,
    app_flat_11: 162,
    char_12: 'serval',
    app_rate_12: '4.96%',
    avg_round_12: 8.28,
    app_flat_12: 98,
    char_13: 'sunday',
    app_rate_13: '4.31%',
    avg_round_13: 8.68,
    app_flat_13: 68,
    char_14: 'lingsha',
    app_rate_14: '3.81%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'feixiao',
    app_rate_15: '1.93%',
    avg_round_15: 9.45,
    app_flat_15: 19,
    char_16: 'acheron',
    app_rate_16: '1.4%',
    avg_round_16: 7.83,
    app_flat_16: 6,
    char_17: 'mydei',
    app_rate_17: '1.23%',
    avg_round_17: 8.6,
    app_flat_17: 29,
    char_18: 'sparkle',
    app_rate_18: '1.2%',
    avg_round_18: 8.83,
    app_flat_18: 6,
    char_19: 'boothill',
    app_rate_19: '1.13%',
    avg_round_19: 8,
    app_flat_19: 18,
    char_20: 'jiaoqiu',
    app_rate_20: '0.95%',
    avg_round_20: 7.8,
    app_flat_20: 5,
    char_21: 'march-7th-swordmaster',
    app_rate_21: '0.95%',
    avg_round_21: 9.67,
    app_flat_21: 12,
    char_22: 'argenti',
    app_rate_22: '0.8%',
    avg_round_22: 7.33,
    app_flat_22: 15,
    char_23: 'topaz',
    app_rate_23: '0.75%',
    avg_round_23: 9,
    app_flat_23: 4,
    char_24: 'aglaea',
    app_rate_24: '0.53%',
    avg_round_24: 9.0,
    app_flat_24: 6,
    char_25: 'bronya',
    app_rate_25: '0.45%',
    avg_round_25: 7.5,
    app_flat_25: 4,
    char_26: 'pela',
    app_rate_26: '0.45%',
    avg_round_26: 9.67,
    app_flat_26: 5,
    char_27: 'yunli',
    app_rate_27: '0.35%',
    avg_round_27: 8.6,
    app_flat_27: 5,
    char_28: 'jing-yuan',
    app_rate_28: '0.25%',
    avg_round_28: 8.67,
    app_flat_28: 3,
    char_29: 'silver-wolf',
    app_rate_29: '0.23%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'imbibitor-lunae',
    app_rate_30: '0.18%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'sunday',
    app: 40.52,
    char_1: 'mydei',
    app_rate_1: '33.46%',
    avg_round_1: 7.59,
    app_flat_1: 652,
    char_2: 'robin',
    app_rate_2: '28.06%',
    avg_round_2: 8.46,
    app_flat_2: 284,
    char_3: 'huohuo',
    app_rate_3: '28.04%',
    avg_round_3: 8.57,
    app_flat_3: 400,
    char_4: 'tribbie',
    app_rate_4: '27.8%',
    avg_round_4: 8.25,
    app_flat_4: 306,
    char_5: 'aglaea',
    app_rate_5: '22.91%',
    avg_round_5: 8.53,
    app_flat_5: 262,
    char_6: 'luocha',
    app_rate_6: '18.72%',
    avg_round_6: 8.0,
    app_flat_6: 295,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '18.4%',
    avg_round_7: 7.16,
    app_flat_7: 319,
    char_8: 'gallagher',
    app_rate_8: '12.98%',
    avg_round_8: 7.9,
    app_flat_8: 222,
    char_9: 'aventurine',
    app_rate_9: '12.51%',
    avg_round_9: 9.19,
    app_flat_9: 103,
    char_10: 'jing-yuan',
    app_rate_10: '12.02%',
    avg_round_10: 9.04,
    app_flat_10: 90,
    char_11: 'the-herta',
    app_rate_11: '11.91%',
    avg_round_11: 8.93,
    app_flat_11: 211,
    char_12: 'ruan-mei',
    app_rate_12: '9.29%',
    avg_round_12: 8.03,
    app_flat_12: 131,
    char_13: 'fu-xuan',
    app_rate_13: '7.25%',
    avg_round_13: 9.21,
    app_flat_13: 68,
    char_14: 'jiaoqiu',
    app_rate_14: '6.34%',
    avg_round_14: 7.72,
    app_flat_14: 34,
    char_15: 'acheron',
    app_rate_15: '5.5%',
    avg_round_15: 8.75,
    app_flat_15: 4,
    char_16: 'herta',
    app_rate_16: '5.21%',
    avg_round_16: 9.26,
    app_flat_16: 100,
    char_17: 'jade',
    app_rate_17: '5.21%',
    avg_round_17: 8.74,
    app_flat_17: 82,
    char_18: 'sparkle',
    app_rate_18: '5.0%',
    avg_round_18: 8,
    app_flat_18: 61,
    char_19: 'lingsha',
    app_rate_19: '4.5%',
    avg_round_19: 8.68,
    app_flat_19: 68,
    char_20: 'imbibitor-lunae',
    app_rate_20: '4.21%',
    avg_round_20: 9.5,
    app_flat_20: 4,
    char_21: 'bronya',
    app_rate_21: '4.19%',
    avg_round_21: 6.59,
    app_flat_21: 54,
    char_22: 'yunli',
    app_rate_22: '2.51%',
    avg_round_22: 8.71,
    app_flat_22: 21,
    char_23: 'jingliu',
    app_rate_23: '1.96%',
    avg_round_23: 9.38,
    app_flat_23: 14,
    char_24: 'serval',
    app_rate_24: '1.81%',
    avg_round_24: 8.19,
    app_flat_24: 30,
    char_25: 'pela',
    app_rate_25: '1.73%',
    avg_round_25: 8.0,
    app_flat_25: 9,
    char_26: 'boothill',
    app_rate_26: '1.1%',
    avg_round_26: 8.38,
    app_flat_26: 8,
    char_27: 'tingyun-fugue',
    app_rate_27: '0.94%',
    avg_round_27: 8.0,
    app_flat_27: 4,
    char_28: 'blade',
    app_rate_28: '0.86%',
    avg_round_28: 8,
    app_flat_28: 3,
    char_29: 'feixiao',
    app_rate_29: '0.84%',
    avg_round_29: 8.56,
    app_flat_29: 9,
    char_30: 'lynx',
    app_rate_30: '0.73%',
    avg_round_30: 7.6,
    app_flat_30: 15
  },
  {
    char: 'aventurine',
    app: 40.42,
    char_1: 'robin',
    app_rate_1: '41.39%',
    avg_round_1: 9.17,
    app_flat_1: 455,
    char_2: 'the-herta',
    app_rate_2: '38.22%',
    avg_round_2: 8.67,
    app_flat_2: 815,
    char_3: 'tribbie',
    app_rate_3: '32.44%',
    avg_round_3: 8.55,
    app_flat_3: 579,
    char_4: 'feixiao',
    app_rate_4: '28.5%',
    avg_round_4: 9.26,
    app_flat_4: 333,
    char_5: 'acheron',
    app_rate_5: '18.69%',
    avg_round_5: 9.02,
    app_flat_5: 94,
    char_6: 'herta',
    app_rate_6: '18.19%',
    avg_round_6: 8.85,
    app_flat_6: 415,
    char_7: 'topaz',
    app_rate_7: '16.98%',
    avg_round_7: 9.24,
    app_flat_7: 165,
    char_8: 'jade',
    app_rate_8: '15.88%',
    avg_round_8: 8.51,
    app_flat_8: 286,
    char_9: 'jiaoqiu',
    app_rate_9: '14.28%',
    avg_round_9: 9.02,
    app_flat_9: 88,
    char_10: 'sunday',
    app_rate_10: '12.55%',
    avg_round_10: 9.19,
    app_flat_10: 103,
    char_11: 'march-7th-swordmaster',
    app_rate_11: '8.79%',
    avg_round_11: 9.31,
    app_flat_11: 139,
    char_12: 'sparkle',
    app_rate_12: '8.37%',
    avg_round_12: 9.67,
    app_flat_12: 24,
    char_13: 'trailblazer-remembrance',
    app_rate_13: '8.22%',
    avg_round_13: 8.99,
    app_flat_13: 187,
    char_14: 'pela',
    app_rate_14: '6.59%',
    avg_round_14: 9.0,
    app_flat_14: 67,
    char_15: 'serval',
    app_rate_15: '5.22%',
    avg_round_15: 8.7,
    app_flat_15: 110,
    char_16: 'jing-yuan',
    app_rate_16: '4.23%',
    avg_round_16: 9.33,
    app_flat_16: 24,
    char_17: 'ruan-mei',
    app_rate_17: '3.7%',
    avg_round_17: 9.29,
    app_flat_17: 39,
    char_18: 'dr-ratio',
    app_rate_18: '2.02%',
    avg_round_18: 9.5,
    app_flat_18: 10,
    char_19: 'tingyun-fugue',
    app_rate_19: '1.47%',
    avg_round_19: 8.81,
    app_flat_19: 21,
    char_20: 'argenti',
    app_rate_20: '1.36%',
    avg_round_20: 7.68,
    app_flat_20: 25,
    char_21: 'aglaea',
    app_rate_21: '1.34%',
    avg_round_21: 8.91,
    app_flat_21: 11,
    char_22: 'bronya',
    app_rate_22: '1.29%',
    avg_round_22: 8,
    app_flat_22: 1,
    char_23: 'silver-wolf',
    app_rate_23: '1.21%',
    avg_round_23: 9,
    app_flat_23: 5,
    char_24: 'imbibitor-lunae',
    app_rate_24: '1.15%',
    avg_round_24: 9.5,
    app_flat_24: 4,
    char_25: 'rappa',
    app_rate_25: '1.15%',
    avg_round_25: 8.86,
    app_flat_25: 22,
    char_26: 'yunli',
    app_rate_26: '1.13%',
    avg_round_26: 9,
    app_flat_26: 7,
    char_27: 'moze',
    app_rate_27: '0.87%',
    avg_round_27: 9.5,
    app_flat_27: 4,
    char_28: 'black-swan',
    app_rate_28: '0.71%',
    avg_round_28: 9.5,
    app_flat_28: 2,
    char_29: 'clara',
    app_rate_29: '0.68%',
    avg_round_29: 9,
    app_flat_29: 6,
    char_30: 'trailblazer-harmony',
    app_rate_30: '0.68%',
    avg_round_30: 9.27,
    app_flat_30: 11
  },
  {
    char: 'robin',
    app: 38.78,
    char_1: 'aventurine',
    app_rate_1: '43.13%',
    avg_round_1: 9.17,
    app_flat_1: 455,
    char_2: 'feixiao',
    app_rate_2: '37.2%',
    avg_round_2: 9.27,
    app_flat_2: 370,
    char_3: 'sunday',
    app_rate_3: '29.32%',
    avg_round_3: 8.46,
    app_flat_3: 284,
    char_4: 'huohuo',
    app_rate_4: '21.53%',
    avg_round_4: 8.76,
    app_flat_4: 249,
    char_5: 'topaz',
    app_rate_5: '19.47%',
    avg_round_5: 9.24,
    app_flat_5: 173,
    char_6: 'aglaea',
    app_rate_6: '17.26%',
    avg_round_6: 8.38,
    app_flat_6: 192,
    char_7: 'the-herta',
    app_rate_7: '15.26%',
    avg_round_7: 8.67,
    app_flat_7: 218,
    char_8: 'jade',
    app_rate_8: '13.54%',
    avg_round_8: 8.52,
    app_flat_8: 186,
    char_9: 'march-7th-swordmaster',
    app_rate_9: '13.13%',
    avg_round_9: 9.31,
    app_flat_9: 160,
    char_10: 'tribbie',
    app_rate_10: '10.28%',
    avg_round_10: 8.89,
    app_flat_10: 71,
    char_11: 'lingsha',
    app_rate_11: '7.69%',
    avg_round_11: 8.46,
    app_flat_11: 96,
    char_12: 'trailblazer-remembrance',
    app_rate_12: '7.66%',
    avg_round_12: 9.0,
    app_flat_12: 53,
    char_13: 'gallagher',
    app_rate_13: '6.62%',
    avg_round_13: 8.32,
    app_flat_13: 81,
    char_14: 'jing-yuan',
    app_rate_14: '6.48%',
    avg_round_14: 8.65,
    app_flat_14: 45,
    char_15: 'yunli',
    app_rate_15: '6.46%',
    avg_round_15: 9.0,
    app_flat_15: 69,
    char_16: 'fu-xuan',
    app_rate_16: '6.18%',
    avg_round_16: 9.02,
    app_flat_16: 45,
    char_17: 'herta',
    app_rate_17: '5.61%',
    avg_round_17: 9.0,
    app_flat_17: 79,
    char_18: 'luocha',
    app_rate_18: '4.18%',
    avg_round_18: 9.48,
    app_flat_18: 43,
    char_19: 'acheron',
    app_rate_19: '2.98%',
    avg_round_19: 10,
    app_flat_19: 3,
    char_20: 'sparkle',
    app_rate_20: '2.76%',
    avg_round_20: 9.4,
    app_flat_20: 5,
    char_21: 'bronya',
    app_rate_21: '2.76%',
    avg_round_21: 4.57,
    app_flat_21: 14,
    char_22: 'mydei',
    app_rate_22: '2.65%',
    avg_round_22: 9.17,
    app_flat_22: 36,
    char_23: 'imbibitor-lunae',
    app_rate_23: '2.6%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'jiaoqiu',
    app_rate_24: '2.46%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'dr-ratio',
    app_rate_25: '2.13%',
    avg_round_25: 9.5,
    app_flat_25: 10,
    char_26: 'moze',
    app_rate_26: '1.48%',
    avg_round_26: 9.5,
    app_flat_26: 4,
    char_27: 'clara',
    app_rate_27: '1.34%',
    avg_round_27: 9.25,
    app_flat_27: 8,
    char_28: 'serval',
    app_rate_28: '1.09%',
    avg_round_28: 7.71,
    app_flat_28: 7,
    char_29: 'jingliu',
    app_rate_29: '0.96%',
    avg_round_29: 8.6,
    app_flat_29: 7,
    char_30: 'ruan-mei',
    app_rate_30: '0.79%',
    avg_round_30: 9,
    app_flat_30: 1
  },
  {
    char: 'tingyun-fugue',
    app: 38.47,
    char_1: 'ruan-mei',
    app_rate_1: '91.45%',
    avg_round_1: 8.94,
    app_flat_1: 874,
    char_2: 'firefly',
    app_rate_2: '67.25%',
    avg_round_2: 9.25,
    app_flat_2: 446,
    char_3: 'lingsha',
    app_rate_3: '52.77%',
    avg_round_3: 9.04,
    app_flat_3: 491,
    char_4: 'trailblazer-harmony',
    app_rate_4: '27.98%',
    avg_round_4: 6.94,
    app_flat_4: 261,
    char_5: 'rappa',
    app_rate_5: '25.37%',
    avg_round_5: 8.45,
    app_flat_5: 483,
    char_6: 'gallagher',
    app_rate_6: '21.86%',
    avg_round_6: 9.29,
    app_flat_6: 296,
    char_7: 'boothill',
    app_rate_7: '5.24%',
    avg_round_7: 8.53,
    app_flat_7: 64,
    char_8: 'aventurine',
    app_rate_8: '1.54%',
    avg_round_8: 8.81,
    app_flat_8: 21,
    char_9: 'huohuo',
    app_rate_9: '1.24%',
    avg_round_9: 9.5,
    app_flat_9: 12,
    char_10: 'bronya',
    app_rate_10: '1.13%',
    avg_round_10: 6.5,
    app_flat_10: 2,
    char_11: 'sunday',
    app_rate_11: '0.99%',
    avg_round_11: 8.0,
    app_flat_11: 4,
    char_12: 'luocha',
    app_rate_12: '0.66%',
    avg_round_12: 9.5,
    app_flat_12: 6,
    char_13: 'tribbie',
    app_rate_13: '0.66%',
    avg_round_13: 7.67,
    app_flat_13: 3,
    char_14: 'acheron',
    app_rate_14: '0.63%',
    avg_round_14: 9.67,
    app_flat_14: 3,
    char_15: 'trailblazer-remembrance',
    app_rate_15: '0.58%',
    avg_round_15: 10,
    app_flat_15: 1,
    char_16: 'fu-xuan',
    app_rate_16: '0.5%',
    avg_round_16: 9.29,
    app_flat_16: 7,
    char_17: 'march-7th-swordmaster',
    app_rate_17: '0.28%',
    avg_round_17: 7.67,
    app_flat_17: 3,
    char_18: 'pela',
    app_rate_18: '0.22%',
    avg_round_18: 9.5,
    app_flat_18: 2,
    char_19: 'silver-wolf',
    app_rate_19: '0.17%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'jiaoqiu',
    app_rate_20: '0.14%',
    avg_round_20: 10,
    app_flat_20: 1,
    char_21: 'himeko',
    app_rate_21: '0.14%',
    avg_round_21: 8,
    app_flat_21: 1,
    char_22: 'sparkle',
    app_rate_22: '0.11%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'herta',
    app_rate_23: '0.08%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'welt',
    app_rate_24: '0.08%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'mydei',
    app_rate_25: '0.06%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'jade',
    app_rate_26: '0.06%',
    avg_round_26: 10,
    app_flat_26: 1,
    char_27: 'asta',
    app_rate_27: '0.06%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'xueyi',
    app_rate_28: '0.06%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'the-herta',
    app_rate_29: '0.06%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'sushang',
    app_rate_30: '0.06%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'firefly',
    app: 35.25,
    char_1: 'ruan-mei',
    app_rate_1: '96.33%',
    avg_round_1: 9.45,
    app_flat_1: 609,
    char_2: 'tingyun-fugue',
    app_rate_2: '73.4%',
    avg_round_2: 9.25,
    app_flat_2: 446,
    char_3: 'lingsha',
    app_rate_3: '49.29%',
    avg_round_3: 9.48,
    app_flat_3: 308,
    char_4: 'trailblazer-harmony',
    app_rate_4: '45.71%',
    avg_round_4: 9.48,
    app_flat_4: 256,
    char_5: 'gallagher',
    app_rate_5: '29.55%',
    avg_round_5: 9.68,
    app_flat_5: 235,
    char_6: 'rappa',
    app_rate_6: '1.35%',
    avg_round_6: 8.0,
    app_flat_6: 11,
    char_7: 'bronya',
    app_rate_7: '0.69%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'aventurine',
    app_rate_8: '0.6%',
    avg_round_8: 10.0,
    app_flat_8: 4,
    char_9: 'huohuo',
    app_rate_9: '0.54%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'luocha',
    app_rate_10: '0.54%',
    avg_round_10: 10,
    app_flat_10: 2,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '0.51%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'tribbie',
    app_rate_12: '0.48%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'fu-xuan',
    app_rate_13: '0.24%',
    avg_round_13: 10,
    app_flat_13: 1,
    char_14: 'sunday',
    app_rate_14: '0.12%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'pela',
    app_rate_15: '0.09%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'asta',
    app_rate_16: '0.09%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'himeko',
    app_rate_17: '0.09%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'march-7th-swordmaster',
    app_rate_18: '0.06%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'jiaoqiu',
    app_rate_19: '0.06%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'boothill',
    app_rate_20: '0.06%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'robin',
    app_rate_21: '0.03%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'sparkle',
    app_rate_22: '0.03%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'bailu',
    app_rate_23: '0.03%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'silver-wolf',
    app_rate_24: '0.03%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'gallagher',
    app: 31.1,
    char_1: 'ruan-mei',
    app_rate_1: '47.95%',
    avg_round_1: 9.5,
    app_flat_1: 499,
    char_2: 'firefly',
    app_rate_2: '33.49%',
    avg_round_2: 9.68,
    app_flat_2: 235,
    char_3: 'tingyun-fugue',
    app_rate_3: '27.05%',
    avg_round_3: 9.29,
    app_flat_3: 296,
    char_4: 'trailblazer-harmony',
    app_rate_4: '24.08%',
    avg_round_4: 9.56,
    app_flat_4: 265,
    char_5: 'tribbie',
    app_rate_5: '22.48%',
    avg_round_5: 7.95,
    app_flat_5: 339,
    char_6: 'the-herta',
    app_rate_6: '21.42%',
    avg_round_6: 8.59,
    app_flat_6: 401,
    char_7: 'sunday',
    app_rate_7: '16.92%',
    avg_round_7: 7.9,
    app_flat_7: 222,
    char_8: 'mydei',
    app_rate_8: '12.79%',
    avg_round_8: 7.97,
    app_flat_8: 230,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '12.69%',
    avg_round_9: 8.62,
    app_flat_9: 223,
    char_10: 'rappa',
    app_rate_10: '11.6%',
    avg_round_10: 9.26,
    app_flat_10: 233,
    char_11: 'herta',
    app_rate_11: '9.35%',
    avg_round_11: 8.94,
    app_flat_11: 186,
    char_12: 'robin',
    app_rate_12: '8.25%',
    avg_round_12: 8.32,
    app_flat_12: 81,
    char_13: 'acheron',
    app_rate_13: '7.88%',
    avg_round_13: 9.12,
    app_flat_13: 65,
    char_14: 'jiaoqiu',
    app_rate_14: '6.38%',
    avg_round_14: 9.03,
    app_flat_14: 66,
    char_15: 'serval',
    app_rate_15: '6.31%',
    avg_round_15: 8.55,
    app_flat_15: 107,
    char_16: 'jade',
    app_rate_16: '5.59%',
    avg_round_16: 7.97,
    app_flat_16: 99,
    char_17: 'pela',
    app_rate_17: '3.99%',
    avg_round_17: 9.31,
    app_flat_17: 57,
    char_18: 'sparkle',
    app_rate_18: '3.79%',
    avg_round_18: 8.38,
    app_flat_18: 37,
    char_19: 'bronya',
    app_rate_19: '2.8%',
    avg_round_19: 9.52,
    app_flat_19: 41,
    char_20: 'boothill',
    app_rate_20: '2.69%',
    avg_round_20: 9.05,
    app_flat_20: 37,
    char_21: 'aglaea',
    app_rate_21: '2.25%',
    avg_round_21: 8.67,
    app_flat_21: 15,
    char_22: 'jing-yuan',
    app_rate_22: '2.15%',
    avg_round_22: 8.8,
    app_flat_22: 20,
    char_23: 'feixiao',
    app_rate_23: '1.33%',
    avg_round_23: 9.5,
    app_flat_23: 6,
    char_24: 'imbibitor-lunae',
    app_rate_24: '1.23%',
    avg_round_24: 6,
    app_flat_24: 1,
    char_25: 'argenti',
    app_rate_25: '1.19%',
    avg_round_25: 6.91,
    app_flat_25: 23,
    char_26: 'march-7th-swordmaster',
    app_rate_26: '0.82%',
    avg_round_26: 9.6,
    app_flat_26: 5,
    char_27: 'yunli',
    app_rate_27: '0.58%',
    avg_round_27: 7.67,
    app_flat_27: 6,
    char_28: 'jingliu',
    app_rate_28: '0.51%',
    avg_round_28: 8.5,
    app_flat_28: 2,
    char_29: 'clara',
    app_rate_29: '0.31%',
    avg_round_29: 9,
    app_flat_29: 3,
    char_30: 'tingyun',
    app_rate_30: '0.31%',
    avg_round_30: 10.0,
    app_flat_30: 4
  },
  {
    char: 'huohuo',
    app: 29.45,
    char_1: 'tribbie',
    app_rate_1: '45.75%',
    avg_round_1: 8.72,
    app_flat_1: 533,
    char_2: 'the-herta',
    app_rate_2: '42.29%',
    avg_round_2: 8.78,
    app_flat_2: 595,
    char_3: 'sunday',
    app_rate_3: '38.58%',
    avg_round_3: 8.57,
    app_flat_3: 400,
    char_4: 'robin',
    app_rate_4: '28.35%',
    avg_round_4: 8.76,
    app_flat_4: 249,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '19.13%',
    avg_round_5: 8.88,
    app_flat_5: 271,
    char_6: 'aglaea',
    app_rate_6: '19.02%',
    avg_round_6: 8.65,
    app_flat_6: 188,
    char_7: 'jade',
    app_rate_7: '18.12%',
    avg_round_7: 8.66,
    app_flat_7: 252,
    char_8: 'herta',
    app_rate_8: '15.56%',
    avg_round_8: 8.92,
    app_flat_8: 225,
    char_9: 'mydei',
    app_rate_9: '10.73%',
    avg_round_9: 8.37,
    app_flat_9: 159,
    char_10: 'serval',
    app_rate_10: '8.79%',
    avg_round_10: 8.88,
    app_flat_10: 111,
    char_11: 'yunli',
    app_rate_11: '7.49%',
    avg_round_11: 9.06,
    app_flat_11: 64,
    char_12: 'sparkle',
    app_rate_12: '6.77%',
    avg_round_12: 9.06,
    app_flat_12: 36,
    char_13: 'ruan-mei',
    app_rate_13: '6.12%',
    avg_round_13: 9.0,
    app_flat_13: 40,
    char_14: 'jing-yuan',
    app_rate_14: '4.39%',
    avg_round_14: 8.62,
    app_flat_14: 24,
    char_15: 'imbibitor-lunae',
    app_rate_15: '4.14%',
    avg_round_15: 10.0,
    app_flat_15: 5,
    char_16: 'feixiao',
    app_rate_16: '2.05%',
    avg_round_16: 9.08,
    app_flat_16: 13,
    char_17: 'acheron',
    app_rate_17: '1.87%',
    avg_round_17: 9.33,
    app_flat_17: 3,
    char_18: 'jiaoqiu',
    app_rate_18: '1.73%',
    avg_round_18: 9.0,
    app_flat_18: 7,
    char_19: 'argenti',
    app_rate_19: '1.66%',
    avg_round_19: 7.78,
    app_flat_19: 27,
    char_20: 'tingyun-fugue',
    app_rate_20: '1.62%',
    avg_round_20: 9.5,
    app_flat_20: 12,
    char_21: 'bronya',
    app_rate_21: '1.62%',
    avg_round_21: 9.33,
    app_flat_21: 17,
    char_22: 'kafka',
    app_rate_22: '1.51%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'march-7th-swordmaster',
    app_rate_23: '1.51%',
    avg_round_23: 8.9,
    app_flat_23: 10,
    char_24: 'tingyun',
    app_rate_24: '1.48%',
    avg_round_24: 8.64,
    app_flat_24: 11,
    char_25: 'rappa',
    app_rate_25: '1.44%',
    avg_round_25: 9.62,
    app_flat_25: 14,
    char_26: 'black-swan',
    app_rate_26: '1.44%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'jingliu',
    app_rate_27: '1.4%',
    avg_round_27: 9.67,
    app_flat_27: 10,
    char_28: 'trailblazer-harmony',
    app_rate_28: '0.9%',
    avg_round_28: 9.25,
    app_flat_28: 6,
    char_29: 'pela',
    app_rate_29: '0.72%',
    avg_round_29: 8.83,
    app_flat_29: 6,
    char_30: 'clara',
    app_rate_30: '0.68%',
    avg_round_30: 8.67,
    app_flat_30: 3
  },
  {
    char: 'trailblazer-remembrance',
    app: 29.1,
    char_1: 'the-herta',
    app_rate_1: '43.42%',
    avg_round_1: 9.06,
    app_flat_1: 736,
    char_2: 'mydei',
    app_rate_2: '31.35%',
    avg_round_2: 7.72,
    app_flat_2: 494,
    char_3: 'sunday',
    app_rate_3: '25.63%',
    avg_round_3: 7.16,
    app_flat_3: 319,
    char_4: 'tribbie',
    app_rate_4: '20.01%',
    avg_round_4: 7.78,
    app_flat_4: 210,
    char_5: 'huohuo',
    app_rate_5: '19.36%',
    avg_round_5: 8.88,
    app_flat_5: 271,
    char_6: 'herta',
    app_rate_6: '16.41%',
    avg_round_6: 9.28,
    app_flat_6: 293,
    char_7: 'jade',
    app_rate_7: '14.91%',
    avg_round_7: 8.97,
    app_flat_7: 246,
    char_8: 'luocha',
    app_rate_8: '14.69%',
    avg_round_8: 8.02,
    app_flat_8: 212,
    char_9: 'gallagher',
    app_rate_9: '13.56%',
    avg_round_9: 8.62,
    app_flat_9: 223,
    char_10: 'aventurine',
    app_rate_10: '11.41%',
    avg_round_10: 8.99,
    app_flat_10: 187,
    char_11: 'robin',
    app_rate_11: '10.21%',
    avg_round_11: 9.0,
    app_flat_11: 53,
    char_12: 'serval',
    app_rate_12: '10.03%',
    avg_round_12: 9.04,
    app_flat_12: 155,
    char_13: 'lingsha',
    app_rate_13: '9.44%',
    avg_round_13: 9.15,
    app_flat_13: 162,
    char_14: 'aglaea',
    app_rate_14: '8.97%',
    avg_round_14: 9.3,
    app_flat_14: 38,
    char_15: 'fu-xuan',
    app_rate_15: '8.53%',
    avg_round_15: 9.5,
    app_flat_15: 98,
    char_16: 'ruan-mei',
    app_rate_16: '6.2%',
    avg_round_16: 6.7,
    app_flat_16: 71,
    char_17: 'sparkle',
    app_rate_17: '5.18%',
    avg_round_17: 8.06,
    app_flat_17: 65,
    char_18: 'bronya',
    app_rate_18: '4.85%',
    avg_round_18: 8.51,
    app_flat_18: 75,
    char_19: 'jiaoqiu',
    app_rate_19: '3.79%',
    avg_round_19: 7.09,
    app_flat_19: 23,
    char_20: 'yunli',
    app_rate_20: '3.76%',
    avg_round_20: 8.66,
    app_flat_20: 38,
    char_21: 'feixiao',
    app_rate_21: '2.81%',
    avg_round_21: 9.4,
    app_flat_21: 18,
    char_22: 'acheron',
    app_rate_22: '2.7%',
    avg_round_22: 7,
    app_flat_22: 3,
    char_23: 'argenti',
    app_rate_23: '2.19%',
    avg_round_23: 6.68,
    app_flat_23: 37,
    char_24: 'pela',
    app_rate_24: '1.49%',
    avg_round_24: 5.9,
    app_flat_24: 10,
    char_25: 'imbibitor-lunae',
    app_rate_25: '1.24%',
    avg_round_25: 10,
    app_flat_25: 1,
    char_26: 'jingliu',
    app_rate_26: '1.13%',
    avg_round_26: 9.25,
    app_flat_26: 8,
    char_27: 'lynx',
    app_rate_27: '0.91%',
    avg_round_27: 8.7,
    app_flat_27: 20,
    char_28: 'tingyun-fugue',
    app_rate_28: '0.77%',
    avg_round_28: 10,
    app_flat_28: 1,
    char_29: 'march-7th-swordmaster',
    app_rate_29: '0.73%',
    avg_round_29: 8,
    app_flat_29: 3,
    char_30: 'jing-yuan',
    app_rate_30: '0.73%',
    avg_round_30: 8.67,
    app_flat_30: 3
  },
  {
    char: 'jade',
    app: 28.26,
    char_1: 'the-herta',
    app_rate_1: '88.85%',
    avg_round_1: 8.59,
    app_flat_1: 1182,
    char_2: 'tribbie',
    app_rate_2: '61.79%',
    avg_round_2: 8.41,
    app_flat_2: 780,
    char_3: 'lingsha',
    app_rate_3: '26.73%',
    avg_round_3: 8.18,
    app_flat_3: 357,
    char_4: 'aventurine',
    app_rate_4: '22.71%',
    avg_round_4: 8.51,
    app_flat_4: 286,
    char_5: 'huohuo',
    app_rate_5: '18.88%',
    avg_round_5: 8.66,
    app_flat_5: 252,
    char_6: 'robin',
    app_rate_6: '18.58%',
    avg_round_6: 8.52,
    app_flat_6: 186,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '15.35%',
    avg_round_7: 8.97,
    app_flat_7: 246,
    char_8: 'fu-xuan',
    app_rate_8: '14.75%',
    avg_round_8: 9.2,
    app_flat_8: 180,
    char_9: 'sunday',
    app_rate_9: '7.47%',
    avg_round_9: 8.74,
    app_flat_9: 82,
    char_10: 'gallagher',
    app_rate_10: '6.16%',
    avg_round_10: 7.97,
    app_flat_10: 99,
    char_11: 'luocha',
    app_rate_11: '4.05%',
    avg_round_11: 9.23,
    app_flat_11: 60,
    char_12: 'ruan-mei',
    app_rate_12: '2.82%',
    avg_round_12: 9.07,
    app_flat_12: 28,
    char_13: 'herta',
    app_rate_13: '2.25%',
    avg_round_13: 9.27,
    app_flat_13: 27,
    char_14: 'feixiao',
    app_rate_14: '2.1%',
    avg_round_14: 8.33,
    app_flat_14: 3,
    char_15: 'sparkle',
    app_rate_15: '2.06%',
    avg_round_15: 9.17,
    app_flat_15: 10,
    char_16: 'blade',
    app_rate_16: '1.13%',
    avg_round_16: 8.57,
    app_flat_16: 7,
    char_17: 'bailu',
    app_rate_17: '0.71%',
    avg_round_17: 9.4,
    app_flat_17: 7,
    char_18: 'bronya',
    app_rate_18: '0.68%',
    avg_round_18: 10.0,
    app_flat_18: 5,
    char_19: 'lynx',
    app_rate_19: '0.41%',
    avg_round_19: 9.5,
    app_flat_19: 2,
    char_20: 'aglaea',
    app_rate_20: '0.3%',
    avg_round_20: 10,
    app_flat_20: 1,
    char_21: 'mydei',
    app_rate_21: '0.26%',
    avg_round_21: 8.25,
    app_flat_21: 4,
    char_22: 'jing-yuan',
    app_rate_22: '0.23%',
    avg_round_22: 8,
    app_flat_22: 2,
    char_23: 'pela',
    app_rate_23: '0.23%',
    avg_round_23: 10,
    app_flat_23: 2,
    char_24: 'yunli',
    app_rate_24: '0.15%',
    avg_round_24: 10,
    app_flat_24: 1,
    char_25: 'clara',
    app_rate_25: '0.11%',
    avg_round_25: 9.5,
    app_flat_25: 2,
    char_26: 'gepard',
    app_rate_26: '0.11%',
    avg_round_26: 9,
    app_flat_26: 1,
    char_27: 'tingyun',
    app_rate_27: '0.11%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'jiaoqiu',
    app_rate_28: '0.11%',
    avg_round_28: 8,
    app_flat_28: 1,
    char_29: 'silver-wolf',
    app_rate_29: '0.08%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'topaz',
    app_rate_30: '0.08%',
    avg_round_30: 10,
    app_flat_30: 1
  },
  {
    char: 'herta',
    app: 26.95,
    char_1: 'the-herta',
    app_rate_1: '96.1%',
    avg_round_1: 8.86,
    app_flat_1: 1337,
    char_2: 'tribbie',
    app_rate_2: '68.67%',
    avg_round_2: 8.5,
    app_flat_2: 913,
    char_3: 'aventurine',
    app_rate_3: '27.27%',
    avg_round_3: 8.85,
    app_flat_3: 415,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '17.71%',
    avg_round_4: 9.28,
    app_flat_4: 293,
    char_5: 'fu-xuan',
    app_rate_5: '17.63%',
    avg_round_5: 9.0,
    app_flat_5: 206,
    char_6: 'huohuo',
    app_rate_6: '17.0%',
    avg_round_6: 8.92,
    app_flat_6: 225,
    char_7: 'lingsha',
    app_rate_7: '15.9%',
    avg_round_7: 8.74,
    app_flat_7: 223,
    char_8: 'gallagher',
    app_rate_8: '10.78%',
    avg_round_8: 8.94,
    app_flat_8: 186,
    char_9: 'robin',
    app_rate_9: '8.07%',
    avg_round_9: 9.0,
    app_flat_9: 79,
    char_10: 'sunday',
    app_rate_10: '7.83%',
    avg_round_10: 9.26,
    app_flat_10: 100,
    char_11: 'luocha',
    app_rate_11: '4.76%',
    avg_round_11: 8.5,
    app_flat_11: 66,
    char_12: 'jade',
    app_rate_12: '2.36%',
    avg_round_12: 9.27,
    app_flat_12: 27,
    char_13: 'sparkle',
    app_rate_13: '1.93%',
    avg_round_13: 9.29,
    app_flat_13: 11,
    char_14: 'ruan-mei',
    app_rate_14: '1.53%',
    avg_round_14: 10.0,
    app_flat_14: 8,
    char_15: 'pela',
    app_rate_15: '0.63%',
    avg_round_15: 9.5,
    app_flat_15: 4,
    char_16: 'bailu',
    app_rate_16: '0.51%',
    avg_round_16: 8.38,
    app_flat_16: 8,
    char_17: 'lynx',
    app_rate_17: '0.31%',
    avg_round_17: 9,
    app_flat_17: 4,
    char_18: 'gepard',
    app_rate_18: '0.24%',
    avg_round_18: 9.67,
    app_flat_18: 3,
    char_19: 'bronya',
    app_rate_19: '0.16%',
    avg_round_19: 9,
    app_flat_19: 2,
    char_20: 'tingyun-fugue',
    app_rate_20: '0.12%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'jiaoqiu',
    app_rate_21: '0.12%',
    avg_round_21: 7,
    app_flat_21: 1,
    char_22: 'march-7th',
    app_rate_22: '0.08%',
    avg_round_22: 8,
    app_flat_22: 1,
    char_23: 'serval',
    app_rate_23: '0.08%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'silver-wolf',
    app_rate_24: '0.04%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'rappa',
    app_rate_25: '0.04%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'feixiao',
    app_rate_26: '0.04%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'tingyun',
    app_rate_27: '0.04%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'hanya',
    app_rate_28: '0.04%',
    avg_round_28: 7,
    app_flat_28: 1,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'trailblazer-harmony',
    app: 23.22,
    char_1: 'ruan-mei',
    app_rate_1: '87.94%',
    avg_round_1: 9.15,
    app_flat_1: 510,
    char_2: 'firefly',
    app_rate_2: '69.39%',
    avg_round_2: 9.48,
    app_flat_2: 256,
    char_3: 'tingyun-fugue',
    app_rate_3: '46.37%',
    avg_round_3: 6.94,
    app_flat_3: 261,
    char_4: 'lingsha',
    app_rate_4: '33.26%',
    avg_round_4: 9.28,
    app_flat_4: 189,
    char_5: 'gallagher',
    app_rate_5: '32.25%',
    avg_round_5: 9.56,
    app_flat_5: 265,
    char_6: 'rappa',
    app_rate_6: '25.67%',
    avg_round_6: 8.67,
    app_flat_6: 339,
    char_7: 'boothill',
    app_rate_7: '2.06%',
    avg_round_7: 7.96,
    app_flat_7: 23,
    char_8: 'aventurine',
    app_rate_8: '1.19%',
    avg_round_8: 9.27,
    app_flat_8: 11,
    char_9: 'huohuo',
    app_rate_9: '1.14%',
    avg_round_9: 9.25,
    app_flat_9: 6,
    char_10: 'tribbie',
    app_rate_10: '0.82%',
    avg_round_10: 9.5,
    app_flat_10: 2,
    char_11: 'luocha',
    app_rate_11: '0.5%',
    avg_round_11: 10.0,
    app_flat_11: 4,
    char_12: 'sunday',
    app_rate_12: '0.41%',
    avg_round_12: 10,
    app_flat_12: 1,
    char_13: 'march-7th-swordmaster',
    app_rate_13: '0.37%',
    avg_round_13: 7.67,
    app_flat_13: 3,
    char_14: 'bronya',
    app_rate_14: '0.32%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'fu-xuan',
    app_rate_15: '0.14%',
    avg_round_15: 10,
    app_flat_15: 1,
    char_16: 'jiaoqiu',
    app_rate_16: '0.14%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'mydei',
    app_rate_17: '0.14%',
    avg_round_17: 10,
    app_flat_17: 1,
    char_18: 'welt',
    app_rate_18: '0.14%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'pela',
    app_rate_19: '0.09%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'lynx',
    app_rate_20: '0.05%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'asta',
    app_rate_21: '0.05%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'xueyi',
    app_rate_22: '0.05%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'sushang',
    app_rate_23: '0.05%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'sparkle',
    app_rate_24: '0.05%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'himeko',
    app_rate_25: '0.05%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'fu-xuan',
    app: 19.93,
    char_1: 'tribbie',
    app_rate_1: '54.23%',
    avg_round_1: 8.9,
    app_flat_1: 392,
    char_2: 'the-herta',
    app_rate_2: '53.96%',
    avg_round_2: 9.05,
    app_flat_2: 467,
    char_3: 'herta',
    app_rate_3: '23.84%',
    avg_round_3: 9.0,
    app_flat_3: 206,
    char_4: 'acheron',
    app_rate_4: '23.04%',
    avg_round_4: 9.28,
    app_flat_4: 57,
    char_5: 'jade',
    app_rate_5: '20.92%',
    avg_round_5: 9.2,
    app_flat_5: 180,
    char_6: 'sparkle',
    app_rate_6: '15.49%',
    avg_round_6: 9.0,
    app_flat_6: 13,
    char_7: 'sunday',
    app_rate_7: '14.74%',
    avg_round_7: 9.21,
    app_flat_7: 68,
    char_8: 'jiaoqiu',
    app_rate_8: '14.0%',
    avg_round_8: 9.26,
    app_flat_8: 45,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '12.45%',
    avg_round_9: 9.5,
    app_flat_9: 98,
    char_10: 'robin',
    app_rate_10: '12.03%',
    avg_round_10: 9.02,
    app_flat_10: 45,
    char_11: 'serval',
    app_rate_11: '9.37%',
    avg_round_11: 9.14,
    app_flat_11: 70,
    char_12: 'pela',
    app_rate_12: '8.52%',
    avg_round_12: 9.22,
    app_flat_12: 43,
    char_13: 'aglaea',
    app_rate_13: '5.64%',
    avg_round_13: 8.91,
    app_flat_13: 22,
    char_14: 'ruan-mei',
    app_rate_14: '3.62%',
    avg_round_14: 9.36,
    app_flat_14: 11,
    char_15: 'silver-wolf',
    app_rate_15: '3.41%',
    avg_round_15: 10,
    app_flat_15: 1,
    char_16: 'jing-yuan',
    app_rate_16: '2.98%',
    avg_round_16: 9.33,
    app_flat_16: 10,
    char_17: 'feixiao',
    app_rate_17: '2.93%',
    avg_round_17: 9.43,
    app_flat_17: 11,
    char_18: 'qingque',
    app_rate_18: '2.13%',
    avg_round_18: 7.33,
    app_flat_18: 3,
    char_19: 'bronya',
    app_rate_19: '1.86%',
    avg_round_19: 10,
    app_flat_19: 2,
    char_20: 'argenti',
    app_rate_20: '1.65%',
    avg_round_20: 8.5,
    app_flat_20: 12,
    char_21: 'march-7th-swordmaster',
    app_rate_21: '1.65%',
    avg_round_21: 9.25,
    app_flat_21: 6,
    char_22: 'jingliu',
    app_rate_22: '1.28%',
    avg_round_22: 9.67,
    app_flat_22: 3,
    char_23: 'yunli',
    app_rate_23: '1.17%',
    avg_round_23: 9,
    app_flat_23: 5,
    char_24: 'imbibitor-lunae',
    app_rate_24: '1.12%',
    avg_round_24: 10,
    app_flat_24: 2,
    char_25: 'tingyun-fugue',
    app_rate_25: '0.96%',
    avg_round_25: 9.29,
    app_flat_25: 7,
    char_26: 'black-swan',
    app_rate_26: '0.8%',
    avg_round_26: 10,
    app_flat_26: 2,
    char_27: 'topaz',
    app_rate_27: '0.75%',
    avg_round_27: 9.5,
    app_flat_27: 2,
    char_28: 'kafka',
    app_rate_28: '0.69%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'blade',
    app_rate_29: '0.69%',
    avg_round_29: 8.33,
    app_flat_29: 3,
    char_30: 'seele',
    app_rate_30: '0.64%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'mydei',
    app: 19.31,
    char_1: 'sunday',
    app_rate_1: '70.22%',
    avg_round_1: 7.59,
    app_flat_1: 652,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '47.25%',
    avg_round_2: 7.72,
    app_flat_2: 494,
    char_3: 'luocha',
    app_rate_3: '41.87%',
    avg_round_3: 8.1,
    app_flat_3: 387,
    char_4: 'tribbie',
    app_rate_4: '32.09%',
    avg_round_4: 8.11,
    app_flat_4: 267,
    char_5: 'gallagher',
    app_rate_5: '20.6%',
    avg_round_5: 7.97,
    app_flat_5: 230,
    char_6: 'ruan-mei',
    app_rate_6: '19.4%',
    avg_round_6: 8.0,
    app_flat_6: 177,
    char_7: 'huohuo',
    app_rate_7: '16.37%',
    avg_round_7: 8.37,
    app_flat_7: 159,
    char_8: 'sparkle',
    app_rate_8: '14.67%',
    avg_round_8: 8.16,
    app_flat_8: 150,
    char_9: 'bronya',
    app_rate_9: '14.34%',
    avg_round_9: 8.62,
    app_flat_9: 160,
    char_10: 'jiaoqiu',
    app_rate_10: '7.47%',
    avg_round_10: 7.21,
    app_flat_10: 52,
    char_11: 'robin',
    app_rate_11: '5.33%',
    avg_round_11: 9.17,
    app_flat_11: 36,
    char_12: 'lingsha',
    app_rate_12: '2.69%',
    avg_round_12: 8.6,
    app_flat_12: 29,
    char_13: 'pela',
    app_rate_13: '1.92%',
    avg_round_13: 8.09,
    app_flat_13: 19,
    char_14: 'lynx',
    app_rate_14: '1.92%',
    avg_round_14: 8.04,
    app_flat_14: 24,
    char_15: 'aventurine',
    app_rate_15: '0.66%',
    avg_round_15: 8.2,
    app_flat_15: 5,
    char_16: 'jade',
    app_rate_16: '0.38%',
    avg_round_16: 8.25,
    app_flat_16: 4,
    char_17: 'fu-xuan',
    app_rate_17: '0.38%',
    avg_round_17: 9,
    app_flat_17: 3,
    char_18: 'march-7th-swordmaster',
    app_rate_18: '0.22%',
    avg_round_18: 7,
    app_flat_18: 2,
    char_19: 'tingyun',
    app_rate_19: '0.22%',
    avg_round_19: 5.5,
    app_flat_19: 2,
    char_20: 'yunli',
    app_rate_20: '0.22%',
    avg_round_20: 8,
    app_flat_20: 1,
    char_21: 'blade',
    app_rate_21: '0.22%',
    avg_round_21: 9,
    app_flat_21: 1,
    char_22: 'bailu',
    app_rate_22: '0.16%',
    avg_round_22: 9.5,
    app_flat_22: 2,
    char_23: 'trailblazer-harmony',
    app_rate_23: '0.16%',
    avg_round_23: 10,
    app_flat_23: 1,
    char_24: 'tingyun-fugue',
    app_rate_24: '0.11%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'black-swan',
    app_rate_25: '0.11%',
    avg_round_25: 10,
    app_flat_25: 1,
    char_26: 'yukong',
    app_rate_26: '0.11%',
    avg_round_26: 7,
    app_flat_26: 1,
    char_27: 'feixiao',
    app_rate_27: '0.05%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'boothill',
    app_rate_28: '0.05%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'jingliu',
    app_rate_29: '0.05%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'silver-wolf',
    app_rate_30: '0.05%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'acheron',
    app: 17.56,
    char_1: 'jiaoqiu',
    app_rate_1: '68.64%',
    avg_round_1: 9.08,
    app_flat_1: 200,
    char_2: 'aventurine',
    app_rate_2: '43.02%',
    avg_round_2: 9.02,
    app_flat_2: 94,
    char_3: 'pela',
    app_rate_3: '34.92%',
    avg_round_3: 9.15,
    app_flat_3: 170,
    char_4: 'sparkle',
    app_rate_4: '32.75%',
    avg_round_4: 9.29,
    app_flat_4: 7,
    char_5: 'fu-xuan',
    app_rate_5: '26.16%',
    avg_round_5: 9.28,
    app_flat_5: 57,
    char_6: 'tribbie',
    app_rate_6: '26.1%',
    avg_round_6: 8.27,
    app_flat_6: 63,
    char_7: 'gallagher',
    app_rate_7: '13.96%',
    avg_round_7: 9.12,
    app_flat_7: 65,
    char_8: 'sunday',
    app_rate_8: '12.69%',
    avg_round_8: 8.75,
    app_flat_8: 4,
    char_9: 'silver-wolf',
    app_rate_9: '6.89%',
    avg_round_9: 9.6,
    app_flat_9: 7,
    char_10: 'robin',
    app_rate_10: '6.59%',
    avg_round_10: 10,
    app_flat_10: 3,
    char_11: 'bronya',
    app_rate_11: '5.44%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'trailblazer-remembrance',
    app_rate_12: '4.47%',
    avg_round_12: 7,
    app_flat_12: 3,
    char_13: 'lingsha',
    app_rate_13: '3.38%',
    avg_round_13: 7.83,
    app_flat_13: 6,
    char_14: 'huohuo',
    app_rate_14: '3.14%',
    avg_round_14: 9.33,
    app_flat_14: 3,
    char_15: 'ruan-mei',
    app_rate_15: '2.78%',
    avg_round_15: 9,
    app_flat_15: 1,
    char_16: 'black-swan',
    app_rate_16: '2.24%',
    avg_round_16: 10.0,
    app_flat_16: 4,
    char_17: 'luocha',
    app_rate_17: '1.57%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'gepard',
    app_rate_18: '1.45%',
    avg_round_18: 10,
    app_flat_18: 3,
    char_19: 'tingyun-fugue',
    app_rate_19: '1.39%',
    avg_round_19: 9.67,
    app_flat_19: 3,
    char_20: 'kafka',
    app_rate_20: '1.27%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'bailu',
    app_rate_21: '0.36%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'lynx',
    app_rate_22: '0.24%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'guinaifen',
    app_rate_23: '0.12%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'the-herta',
    app_rate_24: '0.06%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'serval',
    app_rate_25: '0.06%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'arlan',
    app_rate_26: '0.06%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'aglaea',
    app_rate_27: '0.06%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'feixiao',
    app: 15.21,
    char_1: 'robin',
    app_rate_1: '94.84%',
    avg_round_1: 9.27,
    app_flat_1: 370,
    char_2: 'aventurine',
    app_rate_2: '75.73%',
    avg_round_2: 9.26,
    app_flat_2: 333,
    char_3: 'topaz',
    app_rate_3: '46.37%',
    avg_round_3: 9.23,
    app_flat_3: 165,
    char_4: 'march-7th-swordmaster',
    app_rate_4: '34.17%',
    avg_round_4: 9.36,
    app_flat_4: 169,
    char_5: 'tribbie',
    app_rate_5: '10.04%',
    avg_round_5: 9.44,
    app_flat_5: 32,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '5.37%',
    avg_round_6: 9.4,
    app_flat_6: 18,
    char_7: 'lingsha',
    app_rate_7: '5.37%',
    avg_round_7: 9.45,
    app_flat_7: 19,
    char_8: 'huohuo',
    app_rate_8: '3.97%',
    avg_round_8: 9.08,
    app_flat_8: 13,
    char_9: 'jade',
    app_rate_9: '3.91%',
    avg_round_9: 8.33,
    app_flat_9: 3,
    char_10: 'moze',
    app_rate_10: '3.91%',
    avg_round_10: 9.5,
    app_flat_10: 4,
    char_11: 'fu-xuan',
    app_rate_11: '3.84%',
    avg_round_11: 9.43,
    app_flat_11: 11,
    char_12: 'gallagher',
    app_rate_12: '2.72%',
    avg_round_12: 9.5,
    app_flat_12: 6,
    char_13: 'sunday',
    app_rate_13: '2.23%',
    avg_round_13: 8.56,
    app_flat_13: 9,
    char_14: 'luocha',
    app_rate_14: '1.53%',
    avg_round_14: 10.0,
    app_flat_14: 4,
    char_15: 'bronya',
    app_rate_15: '1.46%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'yunli',
    app_rate_16: '1.19%',
    avg_round_16: 10,
    app_flat_16: 2,
    char_17: 'ruan-mei',
    app_rate_17: '0.98%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'sparkle',
    app_rate_18: '0.98%',
    avg_round_18: 10,
    app_flat_18: 1,
    char_19: 'jiaoqiu',
    app_rate_19: '0.28%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'clara',
    app_rate_20: '0.28%',
    avg_round_20: 9,
    app_flat_20: 1,
    char_21: 'silver-wolf',
    app_rate_21: '0.14%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'mydei',
    app_rate_22: '0.07%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'aglaea',
    app_rate_23: '0.07%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'march-7th',
    app_rate_24: '0.07%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'pela',
    app_rate_25: '0.07%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'lynx',
    app_rate_26: '0.07%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'herta',
    app_rate_27: '0.07%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'tingyun-fugue',
    app_rate_28: '0.07%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'bailu',
    app_rate_29: '0.07%',
    avg_round_29: 10,
    app_flat_29: 1,
    char_30: 'hanya',
    app_rate_30: '0.07%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'luocha',
    app: 14.12,
    char_1: 'mydei',
    app_rate_1: '57.25%',
    avg_round_1: 8.1,
    app_flat_1: 387,
    char_2: 'sunday',
    app_rate_2: '53.72%',
    avg_round_2: 8.0,
    app_flat_2: 295,
    char_3: 'tribbie',
    app_rate_3: '37.19%',
    avg_round_3: 8.33,
    app_flat_3: 222,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '30.28%',
    avg_round_4: 8.02,
    app_flat_4: 212,
    char_5: 'the-herta',
    app_rate_5: '20.66%',
    avg_round_5: 9.04,
    app_flat_5: 148,
    char_6: 'ruan-mei',
    app_rate_6: '12.17%',
    avg_round_6: 9.18,
    app_flat_6: 63,
    char_7: 'robin',
    app_rate_7: '11.5%',
    avg_round_7: 9.48,
    app_flat_7: 43,
    char_8: 'sparkle',
    app_rate_8: '10.97%',
    avg_round_8: 8.75,
    app_flat_8: 56,
    char_9: 'bronya',
    app_rate_9: '9.54%',
    avg_round_9: 8.67,
    app_flat_9: 70,
    char_10: 'herta',
    app_rate_10: '9.09%',
    avg_round_10: 8.5,
    app_flat_10: 66,
    char_11: 'jade',
    app_rate_11: '8.11%',
    avg_round_11: 9.23,
    app_flat_11: 60,
    char_12: 'jiaoqiu',
    app_rate_12: '5.94%',
    avg_round_12: 7.92,
    app_flat_12: 26,
    char_13: 'imbibitor-lunae',
    app_rate_13: '3.98%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'aglaea',
    app_rate_14: '3.83%',
    avg_round_14: 9.2,
    app_flat_14: 9,
    char_15: 'serval',
    app_rate_15: '3.38%',
    avg_round_15: 9.55,
    app_flat_15: 21,
    char_16: 'jing-yuan',
    app_rate_16: '3.01%',
    avg_round_16: 8.18,
    app_flat_16: 11,
    char_17: 'acheron',
    app_rate_17: '1.95%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'blade',
    app_rate_18: '1.88%',
    avg_round_18: 9.5,
    app_flat_18: 2,
    char_19: 'tingyun-fugue',
    app_rate_19: '1.8%',
    avg_round_19: 9.5,
    app_flat_19: 6,
    char_20: 'feixiao',
    app_rate_20: '1.65%',
    avg_round_20: 10.0,
    app_flat_20: 4,
    char_21: 'argenti',
    app_rate_21: '1.43%',
    avg_round_21: 9.0,
    app_flat_21: 7,
    char_22: 'yunli',
    app_rate_22: '1.43%',
    avg_round_22: 10.0,
    app_flat_22: 4,
    char_23: 'firefly',
    app_rate_23: '1.35%',
    avg_round_23: 10,
    app_flat_23: 2,
    char_24: 'rappa',
    app_rate_24: '1.05%',
    avg_round_24: 9,
    app_flat_24: 6,
    char_25: 'pela',
    app_rate_25: '0.9%',
    avg_round_25: 10,
    app_flat_25: 3,
    char_26: 'trailblazer-harmony',
    app_rate_26: '0.83%',
    avg_round_26: 10.0,
    app_flat_26: 4,
    char_27: 'march-7th-swordmaster',
    app_rate_27: '0.83%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'jingliu',
    app_rate_28: '0.83%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'clara',
    app_rate_29: '0.6%',
    avg_round_29: 9.67,
    app_flat_29: 3,
    char_30: 'topaz',
    app_rate_30: '0.53%',
    avg_round_30: 10,
    app_flat_30: 1
  },
  {
    char: 'jiaoqiu',
    app: 14.0,
    char_1: 'acheron',
    app_rate_1: '86.06%',
    avg_round_1: 9.08,
    app_flat_1: 200,
    char_2: 'aventurine',
    app_rate_2: '41.21%',
    avg_round_2: 9.02,
    app_flat_2: 88,
    char_3: 'sparkle',
    app_rate_3: '28.94%',
    avg_round_3: 7.86,
    app_flat_3: 14,
    char_4: 'fu-xuan',
    app_rate_4: '19.92%',
    avg_round_4: 9.26,
    app_flat_4: 45,
    char_5: 'tribbie',
    app_rate_5: '19.92%',
    avg_round_5: 7.79,
    app_flat_5: 43,
    char_6: 'sunday',
    app_rate_6: '18.33%',
    avg_round_6: 7.72,
    app_flat_6: 34,
    char_7: 'pela',
    app_rate_7: '16.14%',
    avg_round_7: 9.14,
    app_flat_7: 139,
    char_8: 'gallagher',
    app_rate_8: '14.17%',
    avg_round_8: 9.03,
    app_flat_8: 66,
    char_9: 'mydei',
    app_rate_9: '10.3%',
    avg_round_9: 7.21,
    app_flat_9: 52,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '7.88%',
    avg_round_10: 7.09,
    app_flat_10: 23,
    char_11: 'robin',
    app_rate_11: '6.82%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'luocha',
    app_rate_12: '5.98%',
    avg_round_12: 7.92,
    app_flat_12: 26,
    char_13: 'bronya',
    app_rate_13: '5.08%',
    avg_round_13: 6,
    app_flat_13: 3,
    char_14: 'huohuo',
    app_rate_14: '3.64%',
    avg_round_14: 9.0,
    app_flat_14: 7,
    char_15: 'ruan-mei',
    app_rate_15: '3.41%',
    avg_round_15: 6.67,
    app_flat_15: 3,
    char_16: 'lingsha',
    app_rate_16: '2.88%',
    avg_round_16: 7.8,
    app_flat_16: 5,
    char_17: 'silver-wolf',
    app_rate_17: '1.21%',
    avg_round_17: 9.2,
    app_flat_17: 5,
    char_18: 'black-swan',
    app_rate_18: '1.14%',
    avg_round_18: 9.67,
    app_flat_18: 3,
    char_19: 'gepard',
    app_rate_19: '0.91%',
    avg_round_19: 10,
    app_flat_19: 2,
    char_20: 'jing-yuan',
    app_rate_20: '0.68%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'kafka',
    app_rate_21: '0.68%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'imbibitor-lunae',
    app_rate_22: '0.45%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'dr-ratio',
    app_rate_23: '0.45%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'bailu',
    app_rate_24: '0.45%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'the-herta',
    app_rate_25: '0.45%',
    avg_round_25: 7,
    app_flat_25: 1,
    char_26: 'tingyun-fugue',
    app_rate_26: '0.38%',
    avg_round_26: 10,
    app_flat_26: 1,
    char_27: 'feixiao',
    app_rate_27: '0.3%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'lynx',
    app_rate_28: '0.23%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'trailblazer-harmony',
    app_rate_29: '0.23%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'herta',
    app_rate_30: '0.23%',
    avg_round_30: 7,
    app_flat_30: 1
  },
  {
    char: 'sparkle',
    app: 13.83,
    char_1: 'acheron',
    app_rate_1: '41.56%',
    avg_round_1: 9.29,
    app_flat_1: 7,
    char_2: 'jiaoqiu',
    app_rate_2: '29.29%',
    avg_round_2: 7.86,
    app_flat_2: 14,
    char_3: 'aventurine',
    app_rate_3: '24.46%',
    avg_round_3: 9.67,
    app_flat_3: 24,
    char_4: 'fu-xuan',
    app_rate_4: '22.32%',
    avg_round_4: 9.0,
    app_flat_4: 13,
    char_5: 'mydei',
    app_rate_5: '20.48%',
    avg_round_5: 8.16,
    app_flat_5: 150,
    char_6: 'tribbie',
    app_rate_6: '18.4%',
    avg_round_6: 8.45,
    app_flat_6: 44,
    char_7: 'sunday',
    app_rate_7: '14.65%',
    avg_round_7: 8,
    app_flat_7: 61,
    char_8: 'huohuo',
    app_rate_8: '14.42%',
    avg_round_8: 9.06,
    app_flat_8: 36,
    char_9: 'imbibitor-lunae',
    app_rate_9: '12.96%',
    avg_round_9: 9.83,
    app_flat_9: 12,
    char_10: 'luocha',
    app_rate_10: '11.2%',
    avg_round_10: 8.75,
    app_flat_10: 56,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '10.89%',
    avg_round_11: 8.06,
    app_flat_11: 65,
    char_12: 'gallagher',
    app_rate_12: '8.51%',
    avg_round_12: 8.38,
    app_flat_12: 37,
    char_13: 'pela',
    app_rate_13: '8.51%',
    avg_round_13: 8,
    app_flat_13: 4,
    char_14: 'robin',
    app_rate_14: '7.75%',
    avg_round_14: 9.4,
    app_flat_14: 5,
    char_15: 'the-herta',
    app_rate_15: '6.67%',
    avg_round_15: 9.3,
    app_flat_15: 18,
    char_16: 'ruan-mei',
    app_rate_16: '6.37%',
    avg_round_16: 7.89,
    app_flat_16: 17,
    char_17: 'silver-wolf',
    app_rate_17: '5.29%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'qingque',
    app_rate_18: '4.37%',
    avg_round_18: 7.57,
    app_flat_18: 7,
    char_19: 'yunli',
    app_rate_19: '4.29%',
    avg_round_19: 9.57,
    app_flat_19: 7,
    char_20: 'jade',
    app_rate_20: '4.22%',
    avg_round_20: 9.17,
    app_flat_20: 10,
    char_21: 'herta',
    app_rate_21: '3.76%',
    avg_round_21: 9.29,
    app_flat_21: 11,
    char_22: 'lingsha',
    app_rate_22: '3.68%',
    avg_round_22: 8.83,
    app_flat_22: 6,
    char_23: 'tingyun',
    app_rate_23: '1.92%',
    avg_round_23: 9.25,
    app_flat_23: 4,
    char_24: 'bronya',
    app_rate_24: '1.92%',
    avg_round_24: 7.36,
    app_flat_24: 14,
    char_25: 'jing-yuan',
    app_rate_25: '1.53%',
    avg_round_25: 9.6,
    app_flat_25: 5,
    char_26: 'clara',
    app_rate_26: '1.38%',
    avg_round_26: 8.67,
    app_flat_26: 3,
    char_27: 'seele',
    app_rate_27: '1.23%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'lynx',
    app_rate_28: '1.07%',
    avg_round_28: 7.17,
    app_flat_28: 6,
    char_29: 'feixiao',
    app_rate_29: '1.07%',
    avg_round_29: 10,
    app_flat_29: 1,
    char_30: 'aglaea',
    app_rate_30: '0.84%',
    avg_round_30: 10,
    app_flat_30: 1
  },
  {
    char: 'rappa',
    app: 12.74,
    char_1: 'ruan-mei',
    app_rate_1: '86.01%',
    avg_round_1: 8.94,
    app_flat_1: 555,
    char_2: 'tingyun-fugue',
    app_rate_2: '76.6%',
    avg_round_2: 8.45,
    app_flat_2: 483,
    char_3: 'lingsha',
    app_rate_3: '47.13%',
    avg_round_3: 8.88,
    app_flat_3: 298,
    char_4: 'trailblazer-harmony',
    app_rate_4: '46.79%',
    avg_round_4: 8.67,
    app_flat_4: 339,
    char_5: 'gallagher',
    app_rate_5: '28.31%',
    avg_round_5: 9.26,
    app_flat_5: 233,
    char_6: 'firefly',
    app_rate_6: '3.75%',
    avg_round_6: 8.0,
    app_flat_6: 11,
    char_7: 'aventurine',
    app_rate_7: '3.66%',
    avg_round_7: 8.86,
    app_flat_7: 22,
    char_8: 'huohuo',
    app_rate_8: '3.33%',
    avg_round_8: 9.62,
    app_flat_8: 14,
    char_9: 'luocha',
    app_rate_9: '1.17%',
    avg_round_9: 9,
    app_flat_9: 6,
    char_10: 'tribbie',
    app_rate_10: '1.17%',
    avg_round_10: 7.5,
    app_flat_10: 4,
    char_11: 'sunday',
    app_rate_11: '0.42%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'fu-xuan',
    app_rate_12: '0.42%',
    avg_round_12: 9,
    app_flat_12: 2,
    char_13: 'silver-wolf',
    app_rate_13: '0.17%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'the-herta',
    app_rate_14: '0.17%',
    avg_round_14: 9,
    app_flat_14: 1,
    char_15: 'jiaoqiu',
    app_rate_15: '0.17%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'boothill',
    app_rate_16: '0.17%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'lynx',
    app_rate_17: '0.08%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'trailblazer-preservation',
    app_rate_18: '0.08%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'sparkle',
    app_rate_19: '0.08%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'herta',
    app_rate_20: '0.08%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'welt',
    app_rate_21: '0.08%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'arlan',
    app_rate_22: '0.08%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'yunli',
    app_rate_23: '0.08%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'serval',
    app: 12.22,
    char_1: 'the-herta',
    app_rate_1: '99.39%',
    avg_round_1: 8.69,
    app_flat_1: 548,
    char_2: 'tribbie',
    app_rate_2: '74.48%',
    avg_round_2: 8.49,
    app_flat_2: 387,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '23.87%',
    avg_round_3: 9.04,
    app_flat_3: 155,
    char_4: 'huohuo',
    app_rate_4: '21.18%',
    avg_round_4: 8.88,
    app_flat_4: 111,
    char_5: 'aventurine',
    app_rate_5: '17.27%',
    avg_round_5: 8.7,
    app_flat_5: 110,
    char_6: 'lingsha',
    app_rate_6: '17.19%',
    avg_round_6: 8.28,
    app_flat_6: 98,
    char_7: 'gallagher',
    app_rate_7: '16.06%',
    avg_round_7: 8.55,
    app_flat_7: 107,
    char_8: 'fu-xuan',
    app_rate_8: '15.28%',
    avg_round_8: 9.14,
    app_flat_8: 70,
    char_9: 'sunday',
    app_rate_9: '5.99%',
    avg_round_9: 8.19,
    app_flat_9: 30,
    char_10: 'luocha',
    app_rate_10: '3.91%',
    avg_round_10: 9.55,
    app_flat_10: 21,
    char_11: 'robin',
    app_rate_11: '3.47%',
    avg_round_11: 7.71,
    app_flat_11: 7,
    char_12: 'ruan-mei',
    app_rate_12: '0.69%',
    avg_round_12: 8,
    app_flat_12: 2,
    char_13: 'sparkle',
    app_rate_13: '0.52%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'herta',
    app_rate_14: '0.17%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'acheron',
    app_rate_15: '0.09%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'jade',
    app_rate_16: '0.09%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'jiaoqiu',
    app_rate_17: '0.09%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'gepard',
    app_rate_18: '0.09%',
    avg_round_18: 9,
    app_flat_18: 1,
    char_19: 'pela',
    app_rate_19: '0.09%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'aglaea',
    app: 10.77,
    char_1: 'sunday',
    app_rate_1: '86.21%',
    avg_round_1: 8.53,
    app_flat_1: 262,
    char_2: 'robin',
    app_rate_2: '62.17%',
    avg_round_2: 8.38,
    app_flat_2: 192,
    char_3: 'huohuo',
    app_rate_3: '52.02%',
    avg_round_3: 8.65,
    app_flat_3: 188,
    char_4: 'tribbie',
    app_rate_4: '28.28%',
    avg_round_4: 8.78,
    app_flat_4: 71,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '24.24%',
    avg_round_5: 9.3,
    app_flat_5: 38,
    char_6: 'fu-xuan',
    app_rate_6: '10.44%',
    avg_round_6: 8.91,
    app_flat_6: 22,
    char_7: 'bronya',
    app_rate_7: '10.44%',
    avg_round_7: 4.38,
    app_flat_7: 16,
    char_8: 'gallagher',
    app_rate_8: '6.5%',
    avg_round_8: 8.67,
    app_flat_8: 15,
    char_9: 'luocha',
    app_rate_9: '5.02%',
    avg_round_9: 9.2,
    app_flat_9: 9,
    char_10: 'aventurine',
    app_rate_10: '5.02%',
    avg_round_10: 8.91,
    app_flat_10: 11,
    char_11: 'ruan-mei',
    app_rate_11: '2.66%',
    avg_round_11: 10,
    app_flat_11: 1,
    char_12: 'lingsha',
    app_rate_12: '2.07%',
    avg_round_12: 9.0,
    app_flat_12: 6,
    char_13: 'bailu',
    app_rate_13: '1.08%',
    avg_round_13: 10.0,
    app_flat_13: 4,
    char_14: 'sparkle',
    app_rate_14: '1.08%',
    avg_round_14: 10,
    app_flat_14: 1,
    char_15: 'jade',
    app_rate_15: '0.79%',
    avg_round_15: 10,
    app_flat_15: 1,
    char_16: 'lynx',
    app_rate_16: '0.49%',
    avg_round_16: 9.5,
    app_flat_16: 2,
    char_17: 'gepard',
    app_rate_17: '0.39%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'tingyun',
    app_rate_18: '0.39%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'feixiao',
    app_rate_19: '0.1%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'march-7th-swordmaster',
    app_rate_20: '0.1%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'acheron',
    app_rate_21: '0.1%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'silver-wolf',
    app_rate_22: '0.1%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'asta',
    app_rate_23: '0.1%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'the-herta',
    app_rate_24: '0.1%',
    avg_round_24: 10,
    app_flat_24: 1,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'topaz',
    app: 7.82,
    char_1: 'robin',
    app_rate_1: '96.61%',
    avg_round_1: 9.24,
    app_flat_1: 173,
    char_2: 'feixiao',
    app_rate_2: '90.23%',
    avg_round_2: 9.23,
    app_flat_2: 165,
    char_3: 'aventurine',
    app_rate_3: '87.79%',
    avg_round_3: 9.24,
    app_flat_3: 165,
    char_4: 'dr-ratio',
    app_rate_4: '7.33%',
    avg_round_4: 9.5,
    app_flat_4: 8,
    char_5: 'lingsha',
    app_rate_5: '4.07%',
    avg_round_5: 9,
    app_flat_5: 4,
    char_6: 'huohuo',
    app_rate_6: '2.31%',
    avg_round_6: 9,
    app_flat_6: 2,
    char_7: 'fu-xuan',
    app_rate_7: '1.9%',
    avg_round_7: 9.5,
    app_flat_7: 2,
    char_8: 'yunli',
    app_rate_8: '1.63%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'tribbie',
    app_rate_9: '1.49%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '1.36%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'luocha',
    app_rate_11: '0.95%',
    avg_round_11: 10,
    app_flat_11: 1,
    char_12: 'bronya',
    app_rate_12: '0.81%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'clara',
    app_rate_13: '0.68%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'ruan-mei',
    app_rate_14: '0.68%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'gallagher',
    app_rate_15: '0.54%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'sunday',
    app_rate_16: '0.27%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'jade',
    app_rate_17: '0.27%',
    avg_round_17: 10,
    app_flat_17: 1,
    char_18: 'march-7th-swordmaster',
    app_rate_18: '0.27%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'moze',
    app_rate_19: '0.27%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'sparkle',
    app_rate_20: '0.27%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'the-herta',
    app_rate_21: '0.14%',
    avg_round_21: 10,
    app_flat_21: 1,
    char_22: 'pela',
    app_rate_22: '0.14%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'pela',
    app: 6.96,
    char_1: 'acheron',
    app_rate_1: '88.11%',
    avg_round_1: 9.15,
    app_flat_1: 170,
    char_2: 'aventurine',
    app_rate_2: '38.26%',
    avg_round_2: 9.0,
    app_flat_2: 67,
    char_3: 'jiaoqiu',
    app_rate_3: '32.47%',
    avg_round_3: 9.14,
    app_flat_3: 139,
    char_4: 'tribbie',
    app_rate_4: '26.68%',
    avg_round_4: 8.19,
    app_flat_4: 30,
    char_5: 'fu-xuan',
    app_rate_5: '24.39%',
    avg_round_5: 9.22,
    app_flat_5: 43,
    char_6: 'gallagher',
    app_rate_6: '17.84%',
    avg_round_6: 9.31,
    app_flat_6: 57,
    char_7: 'sparkle',
    app_rate_7: '16.92%',
    avg_round_7: 8,
    app_flat_7: 4,
    char_8: 'sunday',
    app_rate_8: '10.06%',
    avg_round_8: 8.0,
    app_flat_8: 9,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '6.25%',
    avg_round_9: 5.9,
    app_flat_9: 10,
    char_10: 'bronya',
    app_rate_10: '5.49%',
    avg_round_10: 8.2,
    app_flat_10: 5,
    char_11: 'mydei',
    app_rate_11: '5.34%',
    avg_round_11: 8.09,
    app_flat_11: 19,
    char_12: 'robin',
    app_rate_12: '3.81%',
    avg_round_12: 10,
    app_flat_12: 4,
    char_13: 'huohuo',
    app_rate_13: '3.05%',
    avg_round_13: 8.83,
    app_flat_13: 6,
    char_14: 'lingsha',
    app_rate_14: '2.74%',
    avg_round_14: 9.67,
    app_flat_14: 5,
    char_15: 'ruan-mei',
    app_rate_15: '2.74%',
    avg_round_15: 5.67,
    app_flat_15: 3,
    char_16: 'the-herta',
    app_rate_16: '2.44%',
    avg_round_16: 9.5,
    app_flat_16: 4,
    char_17: 'herta',
    app_rate_17: '2.44%',
    avg_round_17: 9.5,
    app_flat_17: 4,
    char_18: 'luocha',
    app_rate_18: '1.83%',
    avg_round_18: 10,
    app_flat_18: 3,
    char_19: 'gepard',
    app_rate_19: '1.52%',
    avg_round_19: 10,
    app_flat_19: 2,
    char_20: 'silver-wolf',
    app_rate_20: '1.37%',
    avg_round_20: 10,
    app_flat_20: 2,
    char_21: 'tingyun-fugue',
    app_rate_21: '1.22%',
    avg_round_21: 9.5,
    app_flat_21: 2,
    char_22: 'jingliu',
    app_rate_22: '0.91%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'jade',
    app_rate_23: '0.91%',
    avg_round_23: 10,
    app_flat_23: 2,
    char_24: 'firefly',
    app_rate_24: '0.46%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'trailblazer-harmony',
    app_rate_25: '0.3%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'bailu',
    app_rate_26: '0.3%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'jing-yuan',
    app_rate_27: '0.3%',
    avg_round_27: 10,
    app_flat_27: 1,
    char_28: 'dr-ratio',
    app_rate_28: '0.3%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'argenti',
    app_rate_29: '0.15%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'feixiao',
    app_rate_30: '0.15%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'bronya',
    app: 6.3,
    char_1: 'mydei',
    app_rate_1: '43.94%',
    avg_round_1: 8.62,
    app_flat_1: 160,
    char_2: 'sunday',
    app_rate_2: '26.94%',
    avg_round_2: 6.59,
    app_flat_2: 54,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '22.39%',
    avg_round_3: 8.51,
    app_flat_3: 75,
    char_4: 'luocha',
    app_rate_4: '21.38%',
    avg_round_4: 8.67,
    app_flat_4: 70,
    char_5: 'ruan-mei',
    app_rate_5: '17.85%',
    avg_round_5: 7.53,
    app_flat_5: 30,
    char_6: 'aglaea',
    app_rate_6: '17.85%',
    avg_round_6: 4.38,
    app_flat_6: 16,
    char_7: 'robin',
    app_rate_7: '17.0%',
    avg_round_7: 4.57,
    app_flat_7: 14,
    char_8: 'acheron',
    app_rate_8: '15.15%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'tribbie',
    app_rate_9: '14.48%',
    avg_round_9: 7.81,
    app_flat_9: 26,
    char_10: 'gallagher',
    app_rate_10: '13.8%',
    avg_round_10: 9.52,
    app_flat_10: 41,
    char_11: 'jiaoqiu',
    app_rate_11: '11.28%',
    avg_round_11: 6,
    app_flat_11: 3,
    char_12: 'aventurine',
    app_rate_12: '8.25%',
    avg_round_12: 8,
    app_flat_12: 1,
    char_13: 'huohuo',
    app_rate_13: '7.58%',
    avg_round_13: 9.33,
    app_flat_13: 17,
    char_14: 'tingyun-fugue',
    app_rate_14: '6.9%',
    avg_round_14: 6.5,
    app_flat_14: 2,
    char_15: 'pela',
    app_rate_15: '6.06%',
    avg_round_15: 8.2,
    app_flat_15: 5,
    char_16: 'fu-xuan',
    app_rate_16: '5.89%',
    avg_round_16: 10,
    app_flat_16: 2,
    char_17: 'boothill',
    app_rate_17: '4.38%',
    avg_round_17: 6.5,
    app_flat_17: 2,
    char_18: 'sparkle',
    app_rate_18: '4.21%',
    avg_round_18: 7.36,
    app_flat_18: 14,
    char_19: 'firefly',
    app_rate_19: '3.87%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'blade',
    app_rate_20: '3.54%',
    avg_round_20: 9.67,
    app_flat_20: 3,
    char_21: 'feixiao',
    app_rate_21: '3.54%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'lingsha',
    app_rate_22: '3.03%',
    avg_round_22: 7.5,
    app_flat_22: 4,
    char_23: 'jade',
    app_rate_23: '3.03%',
    avg_round_23: 10.0,
    app_flat_23: 5,
    char_24: 'jingliu',
    app_rate_24: '2.69%',
    avg_round_24: 10,
    app_flat_24: 1,
    char_25: 'lynx',
    app_rate_25: '2.36%',
    avg_round_25: 9.75,
    app_flat_25: 8,
    char_26: 'march-7th-swordmaster',
    app_rate_26: '2.02%',
    avg_round_26: 7,
    app_flat_26: 1,
    char_27: 'the-herta',
    app_rate_27: '1.68%',
    avg_round_27: 9.25,
    app_flat_27: 4,
    char_28: 'trailblazer-harmony',
    app_rate_28: '1.18%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'gepard',
    app_rate_29: '1.18%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'jing-yuan',
    app_rate_30: '1.18%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'march-7th-swordmaster',
    app: 5.58,
    char_1: 'feixiao',
    app_rate_1: '93.16%',
    avg_round_1: 9.36,
    app_flat_1: 169,
    char_2: 'robin',
    app_rate_2: '91.25%',
    avg_round_2: 9.31,
    app_flat_2: 160,
    char_3: 'aventurine',
    app_rate_3: '63.69%',
    avg_round_3: 9.31,
    app_flat_3: 139,
    char_4: 'huohuo',
    app_rate_4: '7.98%',
    avg_round_4: 8.9,
    app_flat_4: 10,
    char_5: 'lingsha',
    app_rate_5: '7.22%',
    avg_round_5: 9.67,
    app_flat_5: 12,
    char_6: 'fu-xuan',
    app_rate_6: '5.89%',
    avg_round_6: 9.25,
    app_flat_6: 6,
    char_7: 'gallagher',
    app_rate_7: '4.56%',
    avg_round_7: 9.6,
    app_flat_7: 5,
    char_8: 'tribbie',
    app_rate_8: '4.37%',
    avg_round_8: 9.6,
    app_flat_8: 9,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '3.8%',
    avg_round_9: 8,
    app_flat_9: 3,
    char_10: 'bronya',
    app_rate_10: '2.28%',
    avg_round_10: 7,
    app_flat_10: 1,
    char_11: 'ruan-mei',
    app_rate_11: '2.09%',
    avg_round_11: 7.5,
    app_flat_11: 2,
    char_12: 'luocha',
    app_rate_12: '2.09%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'tingyun-fugue',
    app_rate_13: '1.9%',
    avg_round_13: 7.67,
    app_flat_13: 3,
    char_14: 'sunday',
    app_rate_14: '1.52%',
    avg_round_14: 8.5,
    app_flat_14: 2,
    char_15: 'trailblazer-harmony',
    app_rate_15: '1.52%',
    avg_round_15: 7.67,
    app_flat_15: 3,
    char_16: 'yunli',
    app_rate_16: '1.14%',
    avg_round_16: 9,
    app_flat_16: 2,
    char_17: 'mydei',
    app_rate_17: '0.76%',
    avg_round_17: 7,
    app_flat_17: 2,
    char_18: 'clara',
    app_rate_18: '0.76%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'sparkle',
    app_rate_19: '0.76%',
    avg_round_19: 10,
    app_flat_19: 1,
    char_20: 'dr-ratio',
    app_rate_20: '0.57%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'firefly',
    app_rate_21: '0.38%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'topaz',
    app_rate_22: '0.38%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'jade',
    app_rate_23: '0.38%',
    avg_round_23: 10,
    app_flat_23: 1,
    char_24: 'silver-wolf',
    app_rate_24: '0.19%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'moze',
    app_rate_25: '0.19%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'bailu',
    app_rate_26: '0.19%',
    avg_round_26: 10,
    app_flat_26: 1,
    char_27: 'aglaea',
    app_rate_27: '0.19%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'jing-yuan',
    app_rate_28: '0.19%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'blade',
    app_rate_29: '0.19%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'imbibitor-lunae',
    app_rate_30: '0.19%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'jing-yuan',
    app: 5.0,
    char_1: 'sunday',
    app_rate_1: '97.45%',
    avg_round_1: 9.04,
    app_flat_1: 90,
    char_2: 'robin',
    app_rate_2: '50.32%',
    avg_round_2: 8.65,
    app_flat_2: 45,
    char_3: 'aventurine',
    app_rate_3: '34.18%',
    avg_round_3: 9.33,
    app_flat_3: 24,
    char_4: 'tribbie',
    app_rate_4: '32.48%',
    avg_round_4: 9.06,
    app_flat_4: 33,
    char_5: 'huohuo',
    app_rate_5: '25.9%',
    avg_round_5: 8.62,
    app_flat_5: 24,
    char_6: 'gallagher',
    app_rate_6: '13.38%',
    avg_round_6: 8.8,
    app_flat_6: 20,
    char_7: 'fu-xuan',
    app_rate_7: '11.89%',
    avg_round_7: 9.33,
    app_flat_7: 10,
    char_8: 'luocha',
    app_rate_8: '8.49%',
    avg_round_8: 8.18,
    app_flat_8: 11,
    char_9: 'ruan-mei',
    app_rate_9: '4.67%',
    avg_round_9: 9.5,
    app_flat_9: 4,
    char_10: 'sparkle',
    app_rate_10: '4.25%',
    avg_round_10: 9.6,
    app_flat_10: 5,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '4.25%',
    avg_round_11: 8.67,
    app_flat_11: 3,
    char_12: 'tingyun',
    app_rate_12: '2.34%',
    avg_round_12: 9,
    app_flat_12: 1,
    char_13: 'the-herta',
    app_rate_13: '2.12%',
    avg_round_13: 8,
    app_flat_13: 2,
    char_14: 'lingsha',
    app_rate_14: '2.12%',
    avg_round_14: 8.67,
    app_flat_14: 3,
    char_15: 'jiaoqiu',
    app_rate_15: '1.91%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'bronya',
    app_rate_16: '1.49%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'jade',
    app_rate_17: '1.27%',
    avg_round_17: 8,
    app_flat_17: 2,
    char_18: 'pela',
    app_rate_18: '0.42%',
    avg_round_18: 10,
    app_flat_18: 1,
    char_19: 'bailu',
    app_rate_19: '0.42%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'gepard',
    app_rate_20: '0.21%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'natasha',
    app_rate_21: '0.21%',
    avg_round_21: 8,
    app_flat_21: 1,
    char_22: 'march-7th-swordmaster',
    app_rate_22: '0.21%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'yunli',
    app: 3.68,
    char_1: 'robin',
    app_rate_1: '68.01%',
    avg_round_1: 9.0,
    app_flat_1: 69,
    char_2: 'huohuo',
    app_rate_2: '59.94%',
    avg_round_2: 9.06,
    app_flat_2: 64,
    char_3: 'tribbie',
    app_rate_3: '32.85%',
    avg_round_3: 8.93,
    app_flat_3: 29,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '29.68%',
    avg_round_4: 8.66,
    app_flat_4: 38,
    char_5: 'sunday',
    app_rate_5: '27.67%',
    avg_round_5: 8.71,
    app_flat_5: 21,
    char_6: 'sparkle',
    app_rate_6: '16.14%',
    avg_round_6: 9.57,
    app_flat_6: 7,
    char_7: 'tingyun',
    app_rate_7: '12.97%',
    avg_round_7: 8.92,
    app_flat_7: 12,
    char_8: 'aventurine',
    app_rate_8: '12.39%',
    avg_round_8: 9,
    app_flat_8: 7,
    char_9: 'fu-xuan',
    app_rate_9: '6.34%',
    avg_round_9: 9,
    app_flat_9: 5,
    char_10: 'luocha',
    app_rate_10: '5.48%',
    avg_round_10: 10.0,
    app_flat_10: 4,
    char_11: 'feixiao',
    app_rate_11: '4.9%',
    avg_round_11: 10,
    app_flat_11: 2,
    char_12: 'gallagher',
    app_rate_12: '4.9%',
    avg_round_12: 7.67,
    app_flat_12: 6,
    char_13: 'lingsha',
    app_rate_13: '4.03%',
    avg_round_13: 8.6,
    app_flat_13: 5,
    char_14: 'topaz',
    app_rate_14: '3.46%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'march-7th-swordmaster',
    app_rate_15: '1.73%',
    avg_round_15: 9,
    app_flat_15: 2,
    char_16: 'ruan-mei',
    app_rate_16: '1.44%',
    avg_round_16: 9,
    app_flat_16: 1,
    char_17: 'mydei',
    app_rate_17: '1.15%',
    avg_round_17: 8,
    app_flat_17: 1,
    char_18: 'clara',
    app_rate_18: '1.15%',
    avg_round_18: 9,
    app_flat_18: 1,
    char_19: 'jade',
    app_rate_19: '1.15%',
    avg_round_19: 10,
    app_flat_19: 1,
    char_20: 'bronya',
    app_rate_20: '0.86%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'bailu',
    app_rate_21: '0.86%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'lynx',
    app_rate_22: '0.86%',
    avg_round_22: 10,
    app_flat_22: 1,
    char_23: 'tingyun-fugue',
    app_rate_23: '0.58%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'blade',
    app_rate_24: '0.29%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'the-herta',
    app_rate_25: '0.29%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'natasha',
    app_rate_26: '0.29%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'rappa',
    app_rate_27: '0.29%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'imbibitor-lunae',
    app: 3.09,
    char_1: 'sparkle',
    app_rate_1: '58.08%',
    avg_round_1: 9.83,
    app_flat_1: 12,
    char_2: 'sunday',
    app_rate_2: '55.33%',
    avg_round_2: 9.5,
    app_flat_2: 4,
    char_3: 'huohuo',
    app_rate_3: '39.52%',
    avg_round_3: 10.0,
    app_flat_3: 5,
    char_4: 'robin',
    app_rate_4: '32.65%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'ruan-mei',
    app_rate_5: '24.05%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'luocha',
    app_rate_6: '18.21%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'tribbie',
    app_rate_7: '15.46%',
    avg_round_7: 9.67,
    app_flat_7: 5,
    char_8: 'aventurine',
    app_rate_8: '15.12%',
    avg_round_8: 9.5,
    app_flat_8: 4,
    char_9: 'gallagher',
    app_rate_9: '12.37%',
    avg_round_9: 6,
    app_flat_9: 1,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '11.68%',
    avg_round_10: 10,
    app_flat_10: 1,
    char_11: 'fu-xuan',
    app_rate_11: '7.22%',
    avg_round_11: 10,
    app_flat_11: 2,
    char_12: 'tingyun',
    app_rate_12: '4.47%',
    avg_round_12: 10,
    app_flat_12: 2,
    char_13: 'lingsha',
    app_rate_13: '2.41%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'jiaoqiu',
    app_rate_14: '2.06%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'hanya',
    app_rate_15: '0.69%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'bronya',
    app_rate_16: '0.34%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'march-7th-swordmaster',
    app_rate_17: '0.34%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'argenti',
    app: 2.6,
    char_1: 'the-herta',
    app_rate_1: '91.43%',
    avg_round_1: 7.29,
    app_flat_1: 115,
    char_2: 'tribbie',
    app_rate_2: '75.51%',
    avg_round_2: 7.38,
    app_flat_2: 90,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '24.49%',
    avg_round_3: 6.68,
    app_flat_3: 37,
    char_4: 'aventurine',
    app_rate_4: '21.22%',
    avg_round_4: 7.68,
    app_flat_4: 25,
    char_5: 'huohuo',
    app_rate_5: '18.78%',
    avg_round_5: 7.78,
    app_flat_5: 27,
    char_6: 'gallagher',
    app_rate_6: '14.29%',
    avg_round_6: 6.91,
    app_flat_6: 23,
    char_7: 'lingsha',
    app_rate_7: '13.06%',
    avg_round_7: 7.33,
    app_flat_7: 15,
    char_8: 'fu-xuan',
    app_rate_8: '12.65%',
    avg_round_8: 8.5,
    app_flat_8: 12,
    char_9: 'robin',
    app_rate_9: '8.16%',
    avg_round_9: 9,
    app_flat_9: 3,
    char_10: 'sunday',
    app_rate_10: '8.16%',
    avg_round_10: 6.86,
    app_flat_10: 7,
    char_11: 'luocha',
    app_rate_11: '7.76%',
    avg_round_11: 9.0,
    app_flat_11: 7,
    char_12: 'jiaoqiu',
    app_rate_12: '1.22%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'ruan-mei',
    app_rate_13: '0.82%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'tingyun',
    app_rate_14: '0.82%',
    avg_round_14: 4,
    app_flat_14: 1,
    char_15: 'pela',
    app_rate_15: '0.41%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'sparkle',
    app_rate_16: '0.41%',
    avg_round_16: 8,
    app_flat_16: 1,
    char_17: 'gepard',
    app_rate_17: '0.41%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'jade',
    app_rate_18: '0.41%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'boothill',
    app: 2.45,
    char_1: 'ruan-mei',
    app_rate_1: '93.94%',
    avg_round_1: 8.6,
    app_flat_1: 80,
    char_2: 'tingyun-fugue',
    app_rate_2: '82.25%',
    avg_round_2: 8.53,
    app_flat_2: 64,
    char_3: 'gallagher',
    app_rate_3: '34.2%',
    avg_round_3: 9.05,
    app_flat_3: 37,
    char_4: 'lingsha',
    app_rate_4: '19.48%',
    avg_round_4: 8,
    app_flat_4: 18,
    char_5: 'trailblazer-harmony',
    app_rate_5: '19.48%',
    avg_round_5: 7.96,
    app_flat_5: 23,
    char_6: 'sunday',
    app_rate_6: '18.18%',
    avg_round_6: 8.38,
    app_flat_6: 8,
    char_7: 'bronya',
    app_rate_7: '11.26%',
    avg_round_7: 6.5,
    app_flat_7: 2,
    char_8: 'aventurine',
    app_rate_8: '6.49%',
    avg_round_8: 9.2,
    app_flat_8: 5,
    char_9: 'huohuo',
    app_rate_9: '3.46%',
    avg_round_9: 9,
    app_flat_9: 1,
    char_10: 'fu-xuan',
    app_rate_10: '2.6%',
    avg_round_10: 9.2,
    app_flat_10: 5,
    char_11: 'luocha',
    app_rate_11: '2.16%',
    avg_round_11: 10,
    app_flat_11: 2,
    char_12: 'trailblazer-remembrance',
    app_rate_12: '1.3%',
    avg_round_12: 10,
    app_flat_12: 1,
    char_13: 'tribbie',
    app_rate_13: '0.87%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'silver-wolf',
    app_rate_14: '0.87%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'welt',
    app_rate_15: '0.87%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'firefly',
    app_rate_16: '0.87%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'rappa',
    app_rate_17: '0.87%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'mydei',
    app_rate_18: '0.43%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'pela',
    app_rate_19: '0.43%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'silver-wolf',
    app: 1.54,
    char_1: 'acheron',
    app_rate_1: '78.62%',
    avg_round_1: 9.6,
    app_flat_1: 7,
    char_2: 'sparkle',
    app_rate_2: '47.59%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'fu-xuan',
    app_rate_3: '44.14%',
    avg_round_3: 10,
    app_flat_3: 1,
    char_4: 'aventurine',
    app_rate_4: '31.72%',
    avg_round_4: 9,
    app_flat_4: 5,
    char_5: 'tribbie',
    app_rate_5: '13.79%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'jiaoqiu',
    app_rate_6: '11.03%',
    avg_round_6: 9.2,
    app_flat_6: 5,
    char_7: 'sunday',
    app_rate_7: '8.97%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'lingsha',
    app_rate_8: '6.21%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'pela',
    app_rate_9: '6.21%',
    avg_round_9: 10,
    app_flat_9: 2,
    char_10: 'robin',
    app_rate_10: '5.52%',
    avg_round_10: 9,
    app_flat_10: 1,
    char_11: 'gallagher',
    app_rate_11: '5.52%',
    avg_round_11: 10,
    app_flat_11: 2,
    char_12: 'tingyun-fugue',
    app_rate_12: '4.14%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'bronya',
    app_rate_13: '3.45%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'qingque',
    app_rate_14: '3.45%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'huohuo',
    app_rate_15: '2.76%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'ruan-mei',
    app_rate_16: '2.76%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'seele',
    app_rate_17: '2.76%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'trailblazer-remembrance',
    app_rate_18: '2.07%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'luocha',
    app_rate_19: '2.07%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'dr-ratio',
    app_rate_20: '2.07%',
    avg_round_20: 9,
    app_flat_20: 1,
    char_21: 'rappa',
    app_rate_21: '1.38%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'jade',
    app_rate_22: '1.38%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'feixiao',
    app_rate_23: '1.38%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'boothill',
    app_rate_24: '1.38%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'the-herta',
    app_rate_25: '1.38%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'clara',
    app_rate_26: '1.38%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'lynx',
    app_rate_27: '1.38%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'gepard',
    app_rate_28: '1.38%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'herta',
    app_rate_29: '0.69%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'march-7th-swordmaster',
    app_rate_30: '0.69%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'jingliu',
    app: 1.33,
    char_1: 'tribbie',
    app_rate_1: '64.0%',
    avg_round_1: 9.67,
    app_flat_1: 10,
    char_2: 'sunday',
    app_rate_2: '60.0%',
    avg_round_2: 9.38,
    app_flat_2: 14,
    char_3: 'huohuo',
    app_rate_3: '31.2%',
    avg_round_3: 9.67,
    app_flat_3: 10,
    char_4: 'robin',
    app_rate_4: '28.0%',
    avg_round_4: 8.6,
    app_flat_4: 7,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '24.8%',
    avg_round_5: 9.25,
    app_flat_5: 8,
    char_6: 'fu-xuan',
    app_rate_6: '19.2%',
    avg_round_6: 9.67,
    app_flat_6: 3,
    char_7: 'ruan-mei',
    app_rate_7: '17.6%',
    avg_round_7: 8.67,
    app_flat_7: 3,
    char_8: 'bronya',
    app_rate_8: '12.8%',
    avg_round_8: 10,
    app_flat_8: 1,
    char_9: 'gallagher',
    app_rate_9: '12.0%',
    avg_round_9: 8.5,
    app_flat_9: 2,
    char_10: 'luocha',
    app_rate_10: '8.8%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'sparkle',
    app_rate_11: '5.6%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'pela',
    app_rate_12: '4.8%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'blade',
    app_rate_13: '1.6%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'bailu',
    app_rate_14: '1.6%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'aventurine',
    app_rate_15: '1.6%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'jade',
    app_rate_16: '1.6%',
    avg_round_16: 8,
    app_flat_16: 1,
    char_17: 'tingyun',
    app_rate_17: '0.8%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'mydei',
    app_rate_18: '0.8%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'trailblazer-preservation',
    app_rate_19: '0.8%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'gepard',
    app_rate_20: '0.8%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'silver-wolf',
    app_rate_21: '0.8%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'the-herta',
    app_rate_22: '0.8%',
    avg_round_22: 8,
    app_flat_22: 1,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'black-swan',
    app: 1.08,
    char_1: 'kafka',
    app_rate_1: '68.63%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'huohuo',
    app_rate_2: '39.22%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'ruan-mei',
    app_rate_3: '37.25%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'acheron',
    app_rate_4: '36.27%',
    avg_round_4: 10.0,
    app_flat_4: 4,
    char_5: 'aventurine',
    app_rate_5: '26.47%',
    avg_round_5: 9.5,
    app_flat_5: 2,
    char_6: 'robin',
    app_rate_6: '23.53%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'jiaoqiu',
    app_rate_7: '14.71%',
    avg_round_7: 9.67,
    app_flat_7: 3,
    char_8: 'fu-xuan',
    app_rate_8: '14.71%',
    avg_round_8: 10,
    app_flat_8: 2,
    char_9: 'tribbie',
    app_rate_9: '7.84%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'gallagher',
    app_rate_10: '7.84%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'sparkle',
    app_rate_11: '5.88%',
    avg_round_11: 10,
    app_flat_11: 1,
    char_12: 'luocha',
    app_rate_12: '3.92%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'mydei',
    app_rate_13: '1.96%',
    avg_round_13: 10,
    app_flat_13: 1,
    char_14: 'bronya',
    app_rate_14: '1.96%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'lingsha',
    app_rate_15: '1.96%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'bailu',
    app_rate_16: '1.96%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'tingyun',
    app_rate_17: '0.98%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'sunday',
    app_rate_18: '0.98%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'silver-wolf',
    app_rate_19: '0.98%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'trailblazer-remembrance',
    app_rate_20: '0.98%',
    avg_round_20: 10,
    app_flat_20: 1,
    char_21: 'pela',
    app_rate_21: '0.98%',
    avg_round_21: 10,
    app_flat_21: 1,
    char_22: 'jade',
    app_rate_22: '0.98%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'tingyun',
    app: 1.01,
    char_1: 'yunli',
    app_rate_1: '47.37%',
    avg_round_1: 8.92,
    app_flat_1: 12,
    char_2: 'huohuo',
    app_rate_2: '43.16%',
    avg_round_2: 8.64,
    app_flat_2: 11,
    char_3: 'sparkle',
    app_rate_3: '26.32%',
    avg_round_3: 9.25,
    app_flat_3: 4,
    char_4: 'robin',
    app_rate_4: '24.21%',
    avg_round_4: 9.12,
    app_flat_4: 8,
    char_5: 'sunday',
    app_rate_5: '23.16%',
    avg_round_5: 8.5,
    app_flat_5: 2,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '14.74%',
    avg_round_6: 6.5,
    app_flat_6: 4,
    char_7: 'aventurine',
    app_rate_7: '14.74%',
    avg_round_7: 10,
    app_flat_7: 1,
    char_8: 'imbibitor-lunae',
    app_rate_8: '13.68%',
    avg_round_8: 10,
    app_flat_8: 2,
    char_9: 'tribbie',
    app_rate_9: '12.63%',
    avg_round_9: 8,
    app_flat_9: 2,
    char_10: 'fu-xuan',
    app_rate_10: '12.63%',
    avg_round_10: 10,
    app_flat_10: 1,
    char_11: 'jing-yuan',
    app_rate_11: '11.58%',
    avg_round_11: 9,
    app_flat_11: 1,
    char_12: 'gallagher',
    app_rate_12: '9.47%',
    avg_round_12: 10.0,
    app_flat_12: 4,
    char_13: 'lingsha',
    app_rate_13: '5.26%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'aglaea',
    app_rate_14: '4.21%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'mydei',
    app_rate_15: '4.21%',
    avg_round_15: 5.5,
    app_flat_15: 2,
    char_16: 'qingque',
    app_rate_16: '4.21%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'clara',
    app_rate_17: '4.21%',
    avg_round_17: 9,
    app_flat_17: 2,
    char_18: 'bronya',
    app_rate_18: '3.16%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'luocha',
    app_rate_19: '3.16%',
    avg_round_19: 8,
    app_flat_19: 1,
    char_20: 'jade',
    app_rate_20: '3.16%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'the-herta',
    app_rate_21: '2.11%',
    avg_round_21: 4,
    app_flat_21: 1,
    char_22: 'argenti',
    app_rate_22: '2.11%',
    avg_round_22: 4,
    app_flat_22: 1,
    char_23: 'ruan-mei',
    app_rate_23: '2.11%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'kafka',
    app_rate_24: '1.05%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'black-swan',
    app_rate_25: '1.05%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'jingliu',
    app_rate_26: '1.05%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'herta',
    app_rate_27: '1.05%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'jiaoqiu',
    app_rate_28: '1.05%',
    avg_round_28: 99.99,
    app_flat_28: 0,
    char_29: 'seele',
    app_rate_29: '1.05%',
    avg_round_29: 99.99,
    app_flat_29: 0,
    char_30: 'bailu',
    app_rate_30: '1.05%',
    avg_round_30: 99.99,
    app_flat_30: 0
  },
  {
    char: 'blade',
    app: 0.95,
    char_1: 'tribbie',
    app_rate_1: '65.56%',
    avg_round_1: 8.56,
    app_flat_1: 9,
    char_2: 'sunday',
    app_rate_2: '36.67%',
    avg_round_2: 8,
    app_flat_2: 3,
    char_3: 'jade',
    app_rate_3: '33.33%',
    avg_round_3: 8.57,
    app_flat_3: 7,
    char_4: 'luocha',
    app_rate_4: '27.78%',
    avg_round_4: 9.5,
    app_flat_4: 2,
    char_5: 'bronya',
    app_rate_5: '23.33%',
    avg_round_5: 9.67,
    app_flat_5: 3,
    char_6: 'huohuo',
    app_rate_6: '16.67%',
    avg_round_6: 9,
    app_flat_6: 2,
    char_7: 'robin',
    app_rate_7: '15.56%',
    avg_round_7: 10,
    app_flat_7: 1,
    char_8: 'fu-xuan',
    app_rate_8: '14.44%',
    avg_round_8: 8.33,
    app_flat_8: 3,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '8.89%',
    avg_round_9: 8.67,
    app_flat_9: 3,
    char_10: 'gallagher',
    app_rate_10: '8.89%',
    avg_round_10: 9,
    app_flat_10: 2,
    char_11: 'ruan-mei',
    app_rate_11: '7.78%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'sparkle',
    app_rate_12: '7.78%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'lynx',
    app_rate_13: '7.78%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'aventurine',
    app_rate_14: '5.56%',
    avg_round_14: 8,
    app_flat_14: 1,
    char_15: 'lingsha',
    app_rate_15: '5.56%',
    avg_round_15: 9.5,
    app_flat_15: 2,
    char_16: 'mydei',
    app_rate_16: '4.44%',
    avg_round_16: 9,
    app_flat_16: 1,
    char_17: 'jingliu',
    app_rate_17: '2.22%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'bailu',
    app_rate_18: '2.22%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'clara',
    app_rate_19: '1.11%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'yunli',
    app_rate_20: '1.11%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'jiaoqiu',
    app_rate_21: '1.11%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'march-7th-swordmaster',
    app_rate_22: '1.11%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'kafka',
    app: 0.93,
    char_1: 'black-swan',
    app_rate_1: '79.55%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'huohuo',
    app_rate_2: '47.73%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'ruan-mei',
    app_rate_3: '43.18%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'robin',
    app_rate_4: '26.14%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'acheron',
    app_rate_5: '23.86%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'aventurine',
    app_rate_6: '17.05%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'tribbie',
    app_rate_7: '14.77%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'fu-xuan',
    app_rate_8: '14.77%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'jiaoqiu',
    app_rate_9: '10.23%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'gallagher',
    app_rate_10: '7.95%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'luocha',
    app_rate_11: '3.41%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'lingsha',
    app_rate_12: '3.41%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'bailu',
    app_rate_13: '2.27%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'tingyun',
    app_rate_14: '1.14%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'lynx',
    app_rate_15: '1.14%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'trailblazer-remembrance',
    app_rate_16: '1.14%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'the-herta',
    app_rate_17: '1.14%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'sparkle',
    app_rate_18: '1.14%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'dr-ratio',
    app: 0.89,
    char_1: 'robin',
    app_rate_1: '92.86%',
    avg_round_1: 9.5,
    app_flat_1: 10,
    char_2: 'aventurine',
    app_rate_2: '91.67%',
    avg_round_2: 9.5,
    app_flat_2: 10,
    char_3: 'topaz',
    app_rate_3: '64.29%',
    avg_round_3: 9.5,
    app_flat_3: 8,
    char_4: 'sunday',
    app_rate_4: '13.1%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'moze',
    app_rate_5: '7.14%',
    avg_round_5: 10,
    app_flat_5: 1,
    char_6: 'jiaoqiu',
    app_rate_6: '7.14%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'gallagher',
    app_rate_7: '5.95%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'silver-wolf',
    app_rate_8: '3.57%',
    avg_round_8: 9,
    app_flat_8: 1,
    char_9: 'tribbie',
    app_rate_9: '3.57%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'march-7th-swordmaster',
    app_rate_10: '3.57%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'pela',
    app_rate_11: '2.38%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'bronya',
    app_rate_12: '1.19%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'trailblazer-remembrance',
    app_rate_13: '1.19%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'huohuo',
    app_rate_14: '1.19%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'mydei',
    app_rate_15: '1.19%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'clara',
    app: 0.83,
    char_1: 'robin',
    app_rate_1: '62.82%',
    avg_round_1: 9.25,
    app_flat_1: 8,
    char_2: 'tribbie',
    app_rate_2: '38.46%',
    avg_round_2: 9,
    app_flat_2: 9,
    char_3: 'aventurine',
    app_rate_3: '33.33%',
    avg_round_3: 9,
    app_flat_3: 6,
    char_4: 'huohuo',
    app_rate_4: '24.36%',
    avg_round_4: 8.67,
    app_flat_4: 3,
    char_5: 'sparkle',
    app_rate_5: '23.08%',
    avg_round_5: 8.67,
    app_flat_5: 3,
    char_6: 'sunday',
    app_rate_6: '21.79%',
    avg_round_6: 9.33,
    app_flat_6: 3,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '14.1%',
    avg_round_7: 9,
    app_flat_7: 4,
    char_8: 'gallagher',
    app_rate_8: '11.54%',
    avg_round_8: 9,
    app_flat_8: 3,
    char_9: 'luocha',
    app_rate_9: '10.26%',
    avg_round_9: 9.67,
    app_flat_9: 3,
    char_10: 'fu-xuan',
    app_rate_10: '10.26%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'topaz',
    app_rate_11: '6.41%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'lingsha',
    app_rate_12: '6.41%',
    avg_round_12: 9.5,
    app_flat_12: 2,
    char_13: 'yunli',
    app_rate_13: '5.13%',
    avg_round_13: 9,
    app_flat_13: 1,
    char_14: 'tingyun',
    app_rate_14: '5.13%',
    avg_round_14: 9,
    app_flat_14: 2,
    char_15: 'march-7th-swordmaster',
    app_rate_15: '5.13%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'feixiao',
    app_rate_16: '5.13%',
    avg_round_16: 9,
    app_flat_16: 1,
    char_17: 'jade',
    app_rate_17: '3.85%',
    avg_round_17: 9.5,
    app_flat_17: 2,
    char_18: 'lynx',
    app_rate_18: '3.85%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'silver-wolf',
    app_rate_19: '2.56%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'ruan-mei',
    app_rate_20: '2.56%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'blade',
    app_rate_21: '1.28%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'bronya',
    app_rate_22: '1.28%',
    avg_round_22: 99.99,
    app_flat_22: 0,
    char_23: 'mydei',
    app_rate_23: '1.28%',
    avg_round_23: 10,
    app_flat_23: 1,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'lynx',
    app: 0.78,
    char_1: 'mydei',
    app_rate_1: '47.3%',
    avg_round_1: 8.04,
    app_flat_1: 24,
    char_2: 'sunday',
    app_rate_2: '37.84%',
    avg_round_2: 7.6,
    app_flat_2: 15,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '33.78%',
    avg_round_3: 8.7,
    app_flat_3: 20,
    char_4: 'tribbie',
    app_rate_4: '27.03%',
    avg_round_4: 9.67,
    app_flat_4: 5,
    char_5: 'sparkle',
    app_rate_5: '18.92%',
    avg_round_5: 7.17,
    app_flat_5: 6,
    char_6: 'bronya',
    app_rate_6: '18.92%',
    avg_round_6: 9.75,
    app_flat_6: 8,
    char_7: 'the-herta',
    app_rate_7: '16.22%',
    avg_round_7: 9.17,
    app_flat_7: 6,
    char_8: 'robin',
    app_rate_8: '14.86%',
    avg_round_8: 9,
    app_flat_8: 3,
    char_9: 'jade',
    app_rate_9: '14.86%',
    avg_round_9: 9.5,
    app_flat_9: 2,
    char_10: 'herta',
    app_rate_10: '10.81%',
    avg_round_10: 9,
    app_flat_10: 4,
    char_11: 'blade',
    app_rate_11: '9.46%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'ruan-mei',
    app_rate_12: '9.46%',
    avg_round_12: 8,
    app_flat_12: 1,
    char_13: 'aglaea',
    app_rate_13: '6.76%',
    avg_round_13: 9.5,
    app_flat_13: 2,
    char_14: 'acheron',
    app_rate_14: '5.41%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'jiaoqiu',
    app_rate_15: '4.05%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'clara',
    app_rate_16: '4.05%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'yunli',
    app_rate_17: '4.05%',
    avg_round_17: 10,
    app_flat_17: 1,
    char_18: 'silver-wolf',
    app_rate_18: '2.7%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'rappa',
    app_rate_19: '1.35%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'tingyun-fugue',
    app_rate_20: '1.35%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'trailblazer-harmony',
    app_rate_21: '1.35%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'pela',
    app_rate_22: '1.35%',
    avg_round_22: 10,
    app_flat_22: 1,
    char_23: 'qingque',
    app_rate_23: '1.35%',
    avg_round_23: 99.99,
    app_flat_23: 0,
    char_24: 'seele',
    app_rate_24: '1.35%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'kafka',
    app_rate_25: '1.35%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'feixiao',
    app_rate_26: '1.35%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: 'xueyi',
    app_rate_27: '1.35%',
    avg_round_27: 99.99,
    app_flat_27: 0,
    char_28: 'asta',
    app_rate_28: '1.35%',
    avg_round_28: 9,
    app_flat_28: 1,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'moze',
    app: 0.69,
    char_1: 'feixiao',
    app_rate_1: '86.15%',
    avg_round_1: 9.5,
    app_flat_1: 4,
    char_2: 'robin',
    app_rate_2: '83.08%',
    avg_round_2: 9.5,
    app_flat_2: 4,
    char_3: 'aventurine',
    app_rate_3: '50.77%',
    avg_round_3: 9.5,
    app_flat_3: 4,
    char_4: 'tribbie',
    app_rate_4: '27.69%',
    avg_round_4: 9.5,
    app_flat_4: 2,
    char_5: 'dr-ratio',
    app_rate_5: '9.23%',
    avg_round_5: 10,
    app_flat_5: 1,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '9.23%',
    avg_round_6: 7,
    app_flat_6: 1,
    char_7: 'sunday',
    app_rate_7: '4.62%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'gallagher',
    app_rate_8: '4.62%',
    avg_round_8: 7,
    app_flat_8: 1,
    char_9: 'fu-xuan',
    app_rate_9: '3.08%',
    avg_round_9: 10,
    app_flat_9: 1,
    char_10: 'jiaoqiu',
    app_rate_10: '3.08%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'topaz',
    app_rate_11: '3.08%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'luocha',
    app_rate_12: '3.08%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'huohuo',
    app_rate_13: '1.54%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'march-7th',
    app_rate_14: '1.54%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'march-7th-swordmaster',
    app_rate_15: '1.54%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'jade',
    app_rate_16: '1.54%',
    avg_round_16: 9,
    app_flat_16: 1,
    char_17: 'lingsha',
    app_rate_17: '1.54%',
    avg_round_17: 9,
    app_flat_17: 1,
    char_18: 'ruan-mei',
    app_rate_18: '1.54%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'mydei',
    app_rate_19: '1.54%',
    avg_round_19: 7,
    app_flat_19: 1,
    char_20: 'hanya',
    app_rate_20: '1.54%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'qingque',
    app: 0.66,
    char_1: 'sparkle',
    app_rate_1: '91.94%',
    avg_round_1: 7.57,
    app_flat_1: 7,
    char_2: 'fu-xuan',
    app_rate_2: '64.52%',
    avg_round_2: 7.33,
    app_flat_2: 3,
    char_3: 'tribbie',
    app_rate_3: '54.84%',
    avg_round_3: 7.6,
    app_flat_3: 5,
    char_4: 'huohuo',
    app_rate_4: '17.74%',
    avg_round_4: 7.5,
    app_flat_4: 2,
    char_5: 'sunday',
    app_rate_5: '11.29%',
    avg_round_5: 7.5,
    app_flat_5: 2,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '9.68%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'robin',
    app_rate_7: '9.68%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'aventurine',
    app_rate_8: '8.06%',
    avg_round_8: 9,
    app_flat_8: 1,
    char_9: 'silver-wolf',
    app_rate_9: '8.06%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'tingyun',
    app_rate_10: '6.45%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'the-herta',
    app_rate_11: '4.84%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'gallagher',
    app_rate_12: '4.84%',
    avg_round_12: 7,
    app_flat_12: 1,
    char_13: 'ruan-mei',
    app_rate_13: '3.23%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'luocha',
    app_rate_14: '3.23%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'lynx',
    app_rate_15: '1.61%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'bailu',
    app: 0.64,
    char_1: 'tribbie',
    app_rate_1: '45.0%',
    avg_round_1: 9.22,
    app_flat_1: 15,
    char_2: 'the-herta',
    app_rate_2: '38.33%',
    avg_round_2: 9.15,
    app_flat_2: 13,
    char_3: 'jade',
    app_rate_3: '31.67%',
    avg_round_3: 9.4,
    app_flat_3: 7,
    char_4: 'robin',
    app_rate_4: '23.33%',
    avg_round_4: 9.25,
    app_flat_4: 4,
    char_5: 'sunday',
    app_rate_5: '21.67%',
    avg_round_5: 9.25,
    app_flat_5: 4,
    char_6: 'herta',
    app_rate_6: '21.67%',
    avg_round_6: 8.38,
    app_flat_6: 8,
    char_7: 'aglaea',
    app_rate_7: '18.33%',
    avg_round_7: 10.0,
    app_flat_7: 4,
    char_8: 'sparkle',
    app_rate_8: '15.0%',
    avg_round_8: 10,
    app_flat_8: 1,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '15.0%',
    avg_round_9: 10.0,
    app_flat_9: 5,
    char_10: 'acheron',
    app_rate_10: '10.0%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'jiaoqiu',
    app_rate_11: '10.0%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'ruan-mei',
    app_rate_12: '8.33%',
    avg_round_12: 9,
    app_flat_12: 1,
    char_13: 'mydei',
    app_rate_13: '5.0%',
    avg_round_13: 9.5,
    app_flat_13: 2,
    char_14: 'yunli',
    app_rate_14: '5.0%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'jingliu',
    app_rate_15: '3.33%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'blade',
    app_rate_16: '3.33%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'pela',
    app_rate_17: '3.33%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'bronya',
    app_rate_18: '3.33%',
    avg_round_18: 99.99,
    app_flat_18: 0,
    char_19: 'kafka',
    app_rate_19: '3.33%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: 'black-swan',
    app_rate_20: '3.33%',
    avg_round_20: 99.99,
    app_flat_20: 0,
    char_21: 'jing-yuan',
    app_rate_21: '3.33%',
    avg_round_21: 99.99,
    app_flat_21: 0,
    char_22: 'feixiao',
    app_rate_22: '1.67%',
    avg_round_22: 10,
    app_flat_22: 1,
    char_23: 'march-7th-swordmaster',
    app_rate_23: '1.67%',
    avg_round_23: 10,
    app_flat_23: 1,
    char_24: 'firefly',
    app_rate_24: '1.67%',
    avg_round_24: 99.99,
    app_flat_24: 0,
    char_25: 'tingyun-fugue',
    app_rate_25: '1.67%',
    avg_round_25: 99.99,
    app_flat_25: 0,
    char_26: 'tingyun',
    app_rate_26: '1.67%',
    avg_round_26: 99.99,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'gepard',
    app: 0.43,
    char_1: 'acheron',
    app_rate_1: '58.54%',
    avg_round_1: 10,
    app_flat_1: 3,
    char_2: 'tribbie',
    app_rate_2: '36.59%',
    avg_round_2: 10.0,
    app_flat_2: 4,
    char_3: 'jiaoqiu',
    app_rate_3: '29.27%',
    avg_round_3: 10,
    app_flat_3: 2,
    char_4: 'the-herta',
    app_rate_4: '26.83%',
    avg_round_4: 9.4,
    app_flat_4: 5,
    char_5: 'pela',
    app_rate_5: '24.39%',
    avg_round_5: 10,
    app_flat_5: 2,
    char_6: 'bronya',
    app_rate_6: '17.07%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'sunday',
    app_rate_7: '14.63%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '14.63%',
    avg_round_8: 9,
    app_flat_8: 1,
    char_9: 'herta',
    app_rate_9: '14.63%',
    avg_round_9: 9.67,
    app_flat_9: 3,
    char_10: 'robin',
    app_rate_10: '12.2%',
    avg_round_10: 9.5,
    app_flat_10: 2,
    char_11: 'sparkle',
    app_rate_11: '12.2%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'aglaea',
    app_rate_12: '9.76%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'ruan-mei',
    app_rate_13: '7.32%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'jade',
    app_rate_14: '7.32%',
    avg_round_14: 9,
    app_flat_14: 1,
    char_15: 'silver-wolf',
    app_rate_15: '4.88%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'argenti',
    app_rate_16: '2.44%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'jing-yuan',
    app_rate_17: '2.44%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: 'serval',
    app_rate_18: '2.44%',
    avg_round_18: 9,
    app_flat_18: 1,
    char_19: 'jingliu',
    app_rate_19: '2.44%',
    avg_round_19: 99.99,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'seele',
    app: 0.28,
    char_1: 'sparkle',
    app_rate_1: '61.54%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'tribbie',
    app_rate_2: '57.69%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'fu-xuan',
    app_rate_3: '46.15%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'robin',
    app_rate_4: '34.62%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'sunday',
    app_rate_5: '23.08%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'silver-wolf',
    app_rate_6: '15.38%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '11.54%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'gallagher',
    app_rate_8: '11.54%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'huohuo',
    app_rate_9: '7.69%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'lingsha',
    app_rate_10: '3.85%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'jiaoqiu',
    app_rate_11: '3.85%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'bronya',
    app_rate_12: '3.85%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'jade',
    app_rate_13: '3.85%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'lynx',
    app_rate_14: '3.85%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: 'luocha',
    app_rate_15: '3.85%',
    avg_round_15: 99.99,
    app_flat_15: 0,
    char_16: 'tingyun',
    app_rate_16: '3.85%',
    avg_round_16: 99.99,
    app_flat_16: 0,
    char_17: 'aventurine',
    app_rate_17: '3.85%',
    avg_round_17: 99.99,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'himeko',
    app: 0.17,
    char_1: 'the-herta',
    app_rate_1: '68.75%',
    avg_round_1: 6.5,
    app_flat_1: 4,
    char_2: 'tribbie',
    app_rate_2: '56.25%',
    avg_round_2: 7.2,
    app_flat_2: 5,
    char_3: 'fu-xuan',
    app_rate_3: '37.5%',
    avg_round_3: 7.33,
    app_flat_3: 3,
    char_4: 'tingyun-fugue',
    app_rate_4: '31.25%',
    avg_round_4: 8,
    app_flat_4: 1,
    char_5: 'ruan-mei',
    app_rate_5: '25.0%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'firefly',
    app_rate_6: '18.75%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'aventurine',
    app_rate_7: '18.75%',
    avg_round_7: 6,
    app_flat_7: 1,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '12.5%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'gallagher',
    app_rate_9: '6.25%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'lingsha',
    app_rate_10: '6.25%',
    avg_round_10: 8,
    app_flat_10: 1,
    char_11: 'huohuo',
    app_rate_11: '6.25%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'march-7th-swordmaster',
    app_rate_12: '6.25%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'trailblazer-harmony',
    app_rate_13: '6.25%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'welt',
    app: 0.11,
    char_1: 'ruan-mei',
    app_rate_1: '60.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'sunday',
    app_rate_2: '50.0%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'tingyun-fugue',
    app_rate_3: '30.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'trailblazer-harmony',
    app_rate_4: '30.0%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'gallagher',
    app_rate_5: '20.0%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'boothill',
    app_rate_6: '20.0%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'robin',
    app_rate_7: '20.0%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '10.0%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'sparkle',
    app_rate_9: '10.0%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'tribbie',
    app_rate_10: '10.0%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'fu-xuan',
    app_rate_11: '10.0%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'rappa',
    app_rate_12: '10.0%',
    avg_round_12: 99.99,
    app_flat_12: 0,
    char_13: 'mydei',
    app_rate_13: '10.0%',
    avg_round_13: 99.99,
    app_flat_13: 0,
    char_14: 'luocha',
    app_rate_14: '10.0%',
    avg_round_14: 99.99,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'xueyi',
    app: 0.1,
    char_1: 'tribbie',
    app_rate_1: '66.67%',
    avg_round_1: 10,
    app_flat_1: 1,
    char_2: 'fu-xuan',
    app_rate_2: '44.44%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'sparkle',
    app_rate_3: '33.33%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'bronya',
    app_rate_4: '22.22%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'tingyun-fugue',
    app_rate_5: '22.22%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'ruan-mei',
    app_rate_6: '22.22%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'jade',
    app_rate_7: '22.22%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'sunday',
    app_rate_8: '11.11%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'trailblazer-harmony',
    app_rate_9: '11.11%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'huohuo',
    app_rate_10: '11.11%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: 'lynx',
    app_rate_11: '11.11%',
    avg_round_11: 99.99,
    app_flat_11: 0,
    char_12: 'trailblazer-remembrance',
    app_rate_12: '11.11%',
    avg_round_12: 10,
    app_flat_12: 1,
    char_13: 'aventurine',
    app_rate_13: '11.11%',
    avg_round_13: 10,
    app_flat_13: 1,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'march-7th',
    app: 0.05,
    char_1: 'the-herta',
    app_rate_1: '60.0%',
    avg_round_1: 8,
    app_flat_1: 1,
    char_2: 'tribbie',
    app_rate_2: '60.0%',
    avg_round_2: 8,
    app_flat_2: 1,
    char_3: 'herta',
    app_rate_3: '40.0%',
    avg_round_3: 8,
    app_flat_3: 1,
    char_4: 'jade',
    app_rate_4: '40.0%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'feixiao',
    app_rate_5: '20.0%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'moze',
    app_rate_6: '20.0%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'robin',
    app_rate_7: '20.0%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'pela',
    app_rate_8: '20.0%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'sparkle',
    app_rate_9: '20.0%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'asta',
    app: 0.05,
    char_1: 'firefly',
    app_rate_1: '60.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'ruan-mei',
    app_rate_2: '60.0%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'tingyun-fugue',
    app_rate_3: '40.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'trailblazer-harmony',
    app_rate_4: '20.0%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'gallagher',
    app_rate_5: '20.0%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'mydei',
    app_rate_6: '20.0%',
    avg_round_6: 9,
    app_flat_6: 1,
    char_7: 'bronya',
    app_rate_7: '20.0%',
    avg_round_7: 9,
    app_flat_7: 1,
    char_8: 'lynx',
    app_rate_8: '20.0%',
    avg_round_8: 9,
    app_flat_8: 1,
    char_9: 'aglaea',
    app_rate_9: '20.0%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'sunday',
    app_rate_10: '20.0%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'hanya',
    app: 0.04,
    char_1: 'imbibitor-lunae',
    app_rate_1: '50.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'huohuo',
    app_rate_2: '50.0%',
    avg_round_2: 7,
    app_flat_2: 1,
    char_3: 'sunday',
    app_rate_3: '25.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '25.0%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'luocha',
    app_rate_5: '25.0%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'the-herta',
    app_rate_6: '25.0%',
    avg_round_6: 7,
    app_flat_6: 1,
    char_7: 'herta',
    app_rate_7: '25.0%',
    avg_round_7: 7,
    app_flat_7: 1,
    char_8: 'feixiao',
    app_rate_8: '25.0%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'moze',
    app_rate_9: '25.0%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: 'aventurine',
    app_rate_10: '25.0%',
    avg_round_10: 99.99,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'natasha',
    app: 0.04,
    char_1: 'the-herta',
    app_rate_1: '50.0%',
    avg_round_1: 8,
    app_flat_1: 1,
    char_2: 'jade',
    app_rate_2: '50.0%',
    avg_round_2: 8,
    app_flat_2: 1,
    char_3: 'robin',
    app_rate_3: '50.0%',
    avg_round_3: 8,
    app_flat_3: 1,
    char_4: 'sunday',
    app_rate_4: '50.0%',
    avg_round_4: 8,
    app_flat_4: 1,
    char_5: 'tribbie',
    app_rate_5: '25.0%',
    avg_round_5: 8,
    app_flat_5: 1,
    char_6: 'yunli',
    app_rate_6: '25.0%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '25.0%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'jing-yuan',
    app_rate_8: '25.0%',
    avg_round_8: 8,
    app_flat_8: 1,
    char_9: '',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'yukong',
    app: 0.03,
    char_1: 'mydei',
    app_rate_1: '66.67%',
    avg_round_1: 7,
    app_flat_1: 1,
    char_2: 'jade',
    app_rate_2: '33.33%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'tribbie',
    app_rate_3: '33.33%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'aventurine',
    app_rate_4: '33.33%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'robin',
    app_rate_5: '33.33%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'sunday',
    app_rate_6: '33.33%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '33.33%',
    avg_round_7: 7,
    app_flat_7: 1,
    char_8: 'huohuo',
    app_rate_8: '33.33%',
    avg_round_8: 7,
    app_flat_8: 1,
    char_9: '',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'arlan',
    app: 0.03,
    char_1: 'robin',
    app_rate_1: '33.33%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'sunday',
    app_rate_2: '33.33%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'tribbie',
    app_rate_3: '33.33%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'rappa',
    app_rate_4: '33.33%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'tingyun-fugue',
    app_rate_5: '33.33%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'ruan-mei',
    app_rate_6: '33.33%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: 'acheron',
    app_rate_7: '33.33%',
    avg_round_7: 99.99,
    app_flat_7: 0,
    char_8: 'jiaoqiu',
    app_rate_8: '33.33%',
    avg_round_8: 99.99,
    app_flat_8: 0,
    char_9: 'aventurine',
    app_rate_9: '33.33%',
    avg_round_9: 99.99,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'guinaifen',
    app: 0.02,
    char_1: 'acheron',
    app_rate_1: '100.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'bronya',
    app_rate_2: '50.0%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'fu-xuan',
    app_rate_3: '50.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'jiaoqiu',
    app_rate_4: '50.0%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'aventurine',
    app_rate_5: '50.0%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: '',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'sushang',
    app: 0.02,
    char_1: 'tingyun-fugue',
    app_rate_1: '100.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'lingsha',
    app_rate_2: '100.0%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'trailblazer-harmony',
    app_rate_3: '50.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'ruan-mei',
    app_rate_4: '50.0%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: '',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'hook',
    app: 0.02,
    char_1: 'sparkle',
    app_rate_1: '100.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'tribbie',
    app_rate_2: '100.0%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'lingsha',
    app_rate_3: '50.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'fu-xuan',
    app_rate_4: '50.0%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: '',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'trailblazer-preservation',
    app: 0.02,
    char_1: 'rappa',
    app_rate_1: '50.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'tingyun-fugue',
    app_rate_2: '50.0%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'lingsha',
    app_rate_3: '50.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: 'jingliu',
    app_rate_4: '50.0%',
    avg_round_4: 99.99,
    app_flat_4: 0,
    char_5: 'pela',
    app_rate_5: '50.0%',
    avg_round_5: 99.99,
    app_flat_5: 0,
    char_6: 'tribbie',
    app_rate_6: '50.0%',
    avg_round_6: 99.99,
    app_flat_6: 0,
    char_7: '',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'misha',
    app: 0.01,
    char_1: 'robin',
    app_rate_1: '100.0%',
    avg_round_1: 99.99,
    app_flat_1: 0,
    char_2: 'sunday',
    app_rate_2: '100.0%',
    avg_round_2: 99.99,
    app_flat_2: 0,
    char_3: 'luocha',
    app_rate_3: '100.0%',
    avg_round_3: 99.99,
    app_flat_3: 0,
    char_4: '',
    app_rate_4: '0.00%',
    avg_round_4: 0.0,
    app_flat_4: 0,
    char_5: '',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  }
];
